import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ArrayResponse } from '../models/array_response.interface';
import { BusinessMail } from '../models/business_mail.model';
import { ClockRegisterReviewRequest } from '../models/clock-register-review-request.model';
import {
  StoreWorkingContractWeeklyScheduleExceptionRequestDTO,
  UpdateWorkingContractWeeklyScheduleExceptionRequestPayload,
  WorkingContractWeeklyScheduleExceptionRequest,
  WorkingContractWeeklyScheduleExceptionRequestIndexParams,
  WorkingContractWeeklyScheduleExceptionRequestShowParams,
} from '../models/working-contract-weekly-schedule-exception-request.model';
import { ClockRegister, ClockRegisterClickRequest, ClockRegisterClickResponse, ClockRegisterStatus } from '../models/clock-register.model';
import { CloudflareZoneDns } from '../models/cloudflare_zone_dns.model';
import { Company } from '../models/company.model';
import { PartnerContract } from '../models/partner-contract.model';
import { PartnerContractVariableCondition } from '../models/partner-contract-variable-condition.model';
import { Credential } from '../models/credential.model';
import { Department } from '../models/department.model';
import { DepartmentCategory } from '../models/department_category.model';
import { Domain } from '../models/domain.model';
import { EmployeeCalendarRegister, EmployeeCalendarRegisterWithRelationsSerialized } from '../models/employee_calendar_register.model';
import { EmployeeCalendarRegisterNotificationRequest } from '../models/employee_calendar_register_notification_request.model';
import { HetznerImage } from '../models/hetzner_image.model';
import { HetznerLocation } from '../models/hetzner_location.model';
import { HetznerServerType } from '../models/hetzner_server_type.model';
import { Hosting } from '../models/hosting.model';
import { OvhCart } from '../models/ovh_cart.model';
import { OvhExchangeServer } from '../models/ovh_exchange_server.model';
import { OvhExchangeServerAccount } from '../models/ovh_exchange_server_account.model';
import { OvhGenericProduct } from '../models/ovh_generic_product.model';
import { OvhGenericProductOption } from '../models/ovh_generic_product_option.model';
import { PayrollMileageTripsResponseDTO } from '../models/payroll-mileage-trips-response.dto';
import { CompanyProduct } from '../models/company_product.model';
import { CompanyProductStatusMonitor } from '../models/company_product_status_monitor.model';
import { CompanyProductPhaseStage } from '../models/company_product_phase_stage.model';
import { CompanyProductPhaseType } from 'src/app/models/company_product_phase_type.model';
import { CompanyProductService } from '../models/company_product_service.model';
import { Provider } from '../models/provider.model';
import { Role } from '../models/role.model';
import { User } from '../models/user.model';
import { UserChatOAuthConnection } from '../models/user-chat-oauth-connection.model';
import { UserSlackChatSlot } from '../models/user-slack-chat-slot.model';
import { OAuthAuthorizationsResponse } from '../models/oauth-authorization.model';
import { SlackWorkspace } from '../models/slack-workspace.model';
import { MicrosoftTenant } from '../models/microsoft-tenant.model';
import { GoogleChatCustomer } from '../models/google-chat-customer.model';
import { VacationLimitsConfiguration } from '../models/vacation-limits-configuration.model';
import { MonthVacationAvailability } from '../models/month-vacation-availability.model';
import { UserVacationsResponse } from '../models/user-vacations.interface';
import { WorkingTimeSummary } from '../models/working-time-summary.model';
import { WorkingContract } from '../models/working_contract.model';
import { WorkingContractType } from '../models/working_contract_type.model';
import {
  StoreWorkingContractWeeklySchedulePayload,
  WorkingContractScheduleForWeekResponse,
  WorkingContractWeeklySchedule,
} from '../models/working_contract_weekly_schedule.model';
import {
  WorkingContractWeeklyScheduleException,
  UpdateOrCreateWorkingContractWeeklyScheduleExceptionPayload,
} from '../models/working_contract_weekly_schedule_exception.model';
import { Location, ManageLocationBody, LocationSuggestion } from '../models/location.model';
import { LocationIp } from '../models/location-ip.model';
import { WorkingTime } from '../models/working_time.model';
import { WorkingTimeCategory } from '../models/working_time_category.model';
import { AbsenceRequest, AbsenceRequestUpsertPayload } from '../models/absence_request.model';
import { UtilsService } from './utils.service';
import { CompanyProductPhase } from 'src/app/models/company_product_phase.model';
import { DevelopmentRoadmapResponse } from '../models/development_roadmap.model';
import { DevelopmentAvailability } from '../models/development_availability.model';
import dayjs from 'dayjs';
import { WeeklyWorkingTimeBudget, WeeklyWorkingTimeBudgetInfo } from '../models/weekly_working_time_budget.model';
import {
  WeeklyWorkingTimeBudgetEmployee,
  WeeklyWorkingTimeBudgetEmployeeSerialized,
} from '../models/weekly_working_time_budget_employee.model';
import { CompanyProductPhaseBoard } from '../models/company_product_phase_board.model';
import { ArchiveProductTasksRequest, ProductTask } from '../models/product_task.model';
import { CompanyProductPhaseBoardCol } from '../models/company_product_phase_board_col.model';
import { ProductTaskComment } from '../models/product_task_comment.model';
import { ProductTaskHistoryLog } from '../models/product_task_history_log.model';
import { ProductTaskTagCategory } from '../models/product_task_tag_category.model';
import { ProductTaskTag } from '../models/product_task_tag.model';
import { Holiday } from '../models/holiday.model';
import {
  CommercialDashboardMetrics,
  LeadAssignmentWeightHistoryPeriod,
  LeadAssignmentWeightRow,
  PotentialClient,
  PotentialClientAction,
  PotentialClientComment,
  PotentialClientOrigin,
  PotentialClientStatus,
  PotentialClientStatusChangeRecord,
} from '../models/potential-client.interface';
import { BisualSetting } from '../models/bisual-setting.model';
import { WikiTree } from '../models/wiki-tree.model';
import { WikiNode } from '../models/wiki-node.model';
import { WikiArticle, WikiArticleVersion } from '../models/wiki-article.model';
import { MeetingRecord } from '../models/meeting-record.interface';
import { CreateMediaRecordingBody, MediaRecording, MediaRecordingDiarizationIntervention } from '../models/media-recording.model';
import { CompanyProductPhaseBoardColRole } from '../models/company_product_phase_board_col_role.model';
import { Application } from '../models/application.model';
import { ApplicationType } from '../models/application_type.model';
import { ProgrammingTag } from '../models/programming_tag.model';
import { ApplicationEnvironment } from '../models/application_environment.model';
import { CompanyProductUserMember } from '../models/company_product_user_member.model';
import { WeeklyWorkingTimeBudgetDistributionDistributable } from '../models/weekly_working_time_budget_distribution_distributable.model';
import { CompanyProductDefaultTimeDistribution } from '../models/company_product_default_time_distribution.model';
import { Contract } from '../models/contract.model';
import { ProductTaskMember } from '../models/product_task_member.model';
import { CountryZone } from '../models/country_zone.model';
import { WorkingContractYearCondition } from '../models/working_contract_year_condition.model';
import { Environment } from '../models/environment.model';
import { MessagingConversation } from '../models/messaging_conversation.model';
import { MyCompanyProductRoles } from '../models/my_company_product_roles.model';
import { MyRoles } from '../models/my_roles.model';
import { GuardianScheduledWeek } from '../models/guardian_scheduled_week.model';
import { CompanyProductTeam, UpsertCompanyProductTeamBody } from '../models/company_product_team.model';
import { ProductTaskBoard } from '../models/product_task_board.model';
import { ProductTaskBoardTimeBudget } from '../models/product_task_board_time_budget.model';
import { CompanyProductDefaultTimeDistributionDistributable } from '../models/company_product_default_time_distribution_distributable.model';
import { ProductTaskDistribution } from '../components/main/shared/company-products/product-task-detail/product-task-detail.component';
import { Birthday } from '../models/birthday.model';
import { TodayStatusData } from '../models/today-status-data.model';
import { LearningResourceAchievement } from '../models/learning_resource_achievement.model';
import { LearningResourceEnrollment } from '../models/learning_resource_enrollment.model';
import { JobCandidate, JobCandidateBody, JobCandidateUpdateBody } from '../models/job_candidate.model';
import { ExamInstance, ExamInstanceBody, ExamInstanceFromTemplateBody, ExamInstanceUpdateBody } from '../models/exam_instance.model';
import {
  ExamInstanceEvaluation,
  ExamInstanceEvaluationBody,
  ExamInstanceEvaluationUpdateBody,
} from '../models/exam_instance_evaluation.model';
import { ExamTemplate, ExamTemplateBody } from '../models/exam_template.model';
import { JobDescriptionTemplate, JobDescriptionTemplateBody } from '../models/job_description_template.model';
import {
  SkillQuestion,
  SkillQuestionBody,
  SkillQuestionRubricSuggestionRequest,
  SkillQuestionRubricSuggestionResponse,
} from '../models/skill_question.model';
import { JobVacancy, JobVacancyBody, JobVacancyPhase } from '../models/job_vacancy.model';
import { LearningResource, LearningResourceBody } from '../models/learning_resource.model';
import { Skill, SkillBody } from 'src/app/models/skill.model';
import { SkillCategory, SkillCategoryBody } from 'src/app/models/skill_category.model';
import { AcceptLearningResourceRequestBody, LearningResourceRequest } from '../models/learning_resource_request.model';
import { Computer } from '../models/computer.model';
import { WorkingContractVariableCondition } from '../models/working_contract_variable_condition.model';
import { MyCareerPlan } from '../components/main/employees/performance/my-career-plan/my-career-plan.component';
import { WorkingContractCareerPlan } from '../models/working_contract_career_plan.model';
import { CompanyProductUserMemberRole } from '../models/company_product_user_member_role.model';
import { Payroll } from '../models/payroll.model';
import {
  RemoteWorkExceptionRequest,
  UpdateRemoteWorkExceptionRequestBody,
  UpsertRemoteWorkExceptionRequestBody,
} from '../models/remote_work_exception_request.model';
import { MyCareerPlanNextUpgrade } from '../models/my_career_plan_next_upgrade.model';
import { CompanyProductEpic } from '../models/company_product_epic.model';
import { MarkProductTaskTimeBudgetResponse, ProductTaskTimeBudget } from '../models/product_task_time_budget.model';
import { CompanyProductPhaseTaskTimeAutocalcSetting } from '../models/company_product_phase_task_time_autocalc_setting.model';
import { CompanyProductPhaseBacklogData } from '../components/main/shared/company-products/company-product-detail/company-product-phases/company-product-phase-detail/company-product-phase-backlog/company-product-phase-backlog.component';
import { ProductTaskDesignLink } from '../models/product_task_design_link.model';
import { CompanyProductDeploy } from '../models/company_product_deploy.model';
import { CompanyProductDeployConfiguration } from '../models/company_product_deploy_configuration.model';
import { Observable } from 'rxjs';
import { WorkingContractTemplateCareerPlan } from '../models/working_contract_template_career_plan.model';
import { ProductTaskDeclineReason } from '../models/product_task_decline_reason';
import { Document } from '../models/document.model';
import { DocumentType } from '../models/document_type.model';
import { DocumentRelatedType } from '../enums/document-related-type.enum';
import { Attachment } from '../models/attachment.interface';
import { ProductionPlanification } from '../models/production_planification.model';
import { LongTask } from '../models/long_task.model';
import { LongTaskStatus } from '../enums/long-task-status.enum';
import { BulkDataStructureRequest, BulkDataStructureResponse } from '../models/bulk_data_structure.model';
import { UserMetrics } from '../components/main/employees/performance/my-metrics/my-metrics.component';
import { CompanyMetricsResponse, CompanyMetricIngestHelpResponse } from '../models/company-metric.model';
import { ActiveCompanyObjective } from '../models/active-company-objective.model';
import { OkrManagementTree, OkrMetricOption } from '../models/okr-management.model';
import { WorkingExtraHoursPeriod } from '../models/working-extra-hours-period.model';
import { DrivingRequest, UpdateDrivingRequestBody, DrivingRequestResolutionContext } from '../models/driving_request.model';
import { PendingMeetingAttendance } from '../models/pending-meeting-attendance.interface';
import { ActionsRequired } from '../models/actions-required.interface';
import { RegisterMeetingAttendanceBatchRequest } from '../models/register-meeting-attendance-batch.interface';
import {
  KpiEvaluationsResponse,
  ProductionKeyPerformanceIndicatorEvaluationWithData,
} from '../models/production-key-performance-indicator-evaluation.model';
import { ProductionEfficiencyDetailResponse, ProductionEfficiencyMatrixResponse } from '../models/production-efficiency-matrix.model';
import { ProductionKpiMatrixResponse } from '../models/production-kpi-matrix.model';
import { ProductTaskOriginCategory } from '../models/product_task_origin_category.model';
import { Invoice } from '../models/invoice.model';
import { CompanyProductMonthlyEconomicReport } from '../models/company_product_monthly_economic_report.model';
import { CompanyProductMonthlyEconomicReportInvoiceConciliation } from '../models/company_product_monthly_economic_report_invoice_conciliation.model';
import { HoldedContact } from '../models/holded_contact.model';
import { HoldedChartOfAccount } from '../models/holded_chart_of_account.model';
import { EmployeeRequestResponsibleForAnswer } from '../models/employee-request-responsible-for-answer.model';
import { RemoteWorkStatus } from 'src/app/models/remote-work-status';
import { Survey, UpsertSurveyBody, SurveyKpis } from 'src/app/models/survey.model';
import {
  SurveyVariableConditionSection,
  UpdateSurveyVariableConditionSectionBody,
} from 'src/app/models/survey-variable-condition-section.model';
import {
  CompanyProductPhaseUserPermissions,
  CompanyProductUserPermissions,
} from 'src/app/interfaces/company-product-phase-user-permissions.interface';

export type HttpQueryParams = Record<string, string | number | boolean>;

type HttpRequestOptions = { headers: HttpHeaders };

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private host: string = environment.laravel_url + '/api/v1';

  private http = inject(HttpClient);
  protected utils = inject(UtilsService);

  public getHost() {
    return this.host;
  }

  private setParams(filters: any, params: HttpParams = new HttpParams()) {
    if (filters == null) filters = {};
    Object.entries(filters).forEach((val: [string, any]) => {
      if (val[1] != undefined && val[1] != null) {
        if (val[1] instanceof Date /*|| isdayjs(val[1])*/) val[1] = val[1].toISOString();
        else if (typeof val[1] === 'boolean') val[1] = val[1] ? 1 : 0;
        params = params.set(val[0], val[1]);
      }
    });

    return params;
  }

  private buildSilentRequestHeaders(silent?: boolean): HttpHeaders | undefined {
    if (!silent) {
      return undefined;
    }

    return new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true');
  }

  /**
   * -------------------------------------------------- AUTHENTICATION --------------------------------------------------
   */
  authMe() {
    return this.http.post<User>(`${this.host}/auth/me`, {});
  }

  logout() {
    return this.http.post<{ message: string }>(
      `${this.host}/auth/logout`,
      {},
      {
        headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
      }
    );
  }

  resetPassword(body: any) {
    return this.http.post<any>(`${this.host}/auth/reset-password`, body);
  }

  impersonate(data: any) {
    return this.http.post<{ access_token: string; refresh_token?: string; expires_in?: number; user: User }>(
      `${this.host}/auth/impersonate/`,
      data
    );
  }

  /**
   * -------------------------------------------------- ME --------------------------------------------------
   */
  me() {
    return this.http.get<User>(`${this.host}/me`);
  }

  myClockRegisterStatus() {
    return this.http.get<ClockRegisterStatus>(`${this.host}/me/clock-register-status`);
  }

  clickClockRegister(body: ClockRegisterClickRequest): Observable<ClockRegisterClickResponse> {
    return this.http.post<ClockRegisterClickResponse>(`${this.host}/me/click`, body);
  }

  clickClockRestRegister(data: any) {
    return this.http.post<any>(`${this.host}/me/click/rest`, data);
  }

  getRemoteWorkStatus(): Observable<RemoteWorkStatus> {
    return this.http.get<RemoteWorkStatus>(`${this.host}/me/remote-work-status`);
  }

  getMyAbsences(from: Date, to: Date) {
    return this.http
      .get<{
        holidays: Holiday[];
        employee_calendar_registers: EmployeeCalendarRegister[];
      }>(`${this.host}/me/absences`, {
        params: {
          from: this.utils.dateToStringYYYYMMDD(from),
          to: this.utils.dateToStringYYYYMMDD(to),
        },
      })
      .pipe(
        map(absences => {
          // vacation_requests ya no existe, se eliminó con el modelo VacationRequest
          // Las vacaciones ahora vienen en employee_calendar_registers
          if (absences.holidays && Array.isArray(absences.holidays)) {
            absences.holidays = absences.holidays.map(h => {
              h.date = new Date(h.date);
              return h;
            });
          }
          if (absences.employee_calendar_registers && Array.isArray(absences.employee_calendar_registers)) {
            absences.employee_calendar_registers = absences.employee_calendar_registers.map(ecr => {
              ecr.from_date = new Date(ecr.from_date);
              ecr.to_date = new Date(ecr.to_date);
              return ecr;
            });
          }
          return absences;
        })
      );
  }

  getMyCompanyProductRoles() {
    return this.http.get<MyCompanyProductRoles>(`${this.host}/me/company-product-roles`);
  }

  getMyRoles() {
    return this.http.get<MyRoles>(`${this.host}/me/roles`);
  }

  getMyGuardianStatus() {
    return this.http.get<{
      active: boolean;
      company_product_names: string | undefined;
    }>(`${this.host}/me/guardian-status`);
  }

  getMyCompanyProductTeams() {
    return this.http.get<CompanyProductTeam[]>(`${this.host}/me/company-product-teams`);
  }

  getMyActionsRequired(): Observable<ActionsRequired> {
    return this.http.get<ActionsRequired>(`${this.host}/me/actions-required`);
  }

  getMyOAuthAuthorizations() {
    return this.http.get<OAuthAuthorizationsResponse>(`${this.host}/me/oauth-authorizations`);
  }

  revokeMyOAuthAuthorization(client_id: string) {
    return this.http.delete<{ ok: boolean }>(`${this.host}/me/oauth-authorizations/${client_id}`);
  }

  getPendingMeetingAttendances(): Observable<PendingMeetingAttendance[]> {
    return this.http.get<PendingMeetingAttendance[]>(`${this.host}/me/pending-meeting-attendances`);
  }

  registerMeetingAttendanceBatch(data: RegisterMeetingAttendanceBatchRequest): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`${this.host}/me/register-meeting-attendance-batch`, data);
  }

  getMyPayrolls(params: any = {}) {
    return this.http.get<ArrayResponse<Payroll>>(`${this.host}/me/payrolls`, { params: params });
  }

  getMyAbsencesRequests(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<AbsenceRequest>>(`${this.host}/me/absence-requests`, { params: http_params });
  }

  getMyDayMetrics() {
    return this.http.get<UserMetrics>(`${this.host}/me/day-metrics`);
  }

  getMyKpiEvaluations(params: HttpParams): Observable<KpiEvaluationsResponse> {
    return this.http.get<KpiEvaluationsResponse>(`${this.host}/me/production-key-performance-indicator-evaluations`, { params });
  }

  getCompanyProductKpiEvaluations(company_product_id: number, params: HttpParams): Observable<KpiEvaluationsResponse> {
    return this.http.get<KpiEvaluationsResponse>(
      `${this.host}/company-products/${company_product_id}/production-key-performance-indicator-evaluations`,
      { params }
    );
  }

  getProductionKpiMatrix(params: HttpParams): Observable<ProductionKpiMatrixResponse> {
    return this.http.get<ProductionKpiMatrixResponse>(`${this.host}/production-key-performance-indicator-evaluations/matrix`, {
      params,
    });
  }

  getProductionEfficiencyMatrix(params: HttpParams): Observable<ProductionEfficiencyMatrixResponse> {
    return this.http.get<ProductionEfficiencyMatrixResponse>(`${this.host}/company-products/production-efficiency-matrix`, { params });
  }

  getProductionEfficiencyDetail(params: HttpParams): Observable<ProductionEfficiencyDetailResponse> {
    return this.http.get<ProductionEfficiencyDetailResponse>(`${this.host}/company-products/production-efficiency-detail`, { params });
  }

  getProductionKpiEvaluationDetail(params: HttpParams): Observable<ProductionKeyPerformanceIndicatorEvaluationWithData> {
    return this.http.get<ProductionKeyPerformanceIndicatorEvaluationWithData>(
      `${this.host}/production-key-performance-indicator-evaluations/detail`,
      { params }
    );
  }

  /**
   * -------------------------------------------------- BLOGPOSTS --------------------------------------------------
   */
  getAllBlogposts() {
    return this.http.get<any>(`${this.host}/blogposts`);
  }

  /**
   * -------------------------------------------------- WORKING CONTRACTS TYPES --------------------------------------------------
   */

  getWorkingContractsTypes(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<WorkingContractType[]>(`${this.host}/working-contracts-types`, { params: http_params });
  }

  /**
   * -------------------------------------------------- WORKING CONTRACTS --------------------------------------------------
   */
  getWorkingContractsPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<WorkingContract>>(`${this.host}/working-contracts`, { params: http_params });
  }

  getWorkingContract(id: number, params: any = {}) {
    return this.http.get<WorkingContract>(`${this.host}/working-contracts/${id}`, { params: params });
  }

  updateWorkingContract(id: string, body: any) {
    return this.http.put<WorkingContract>(`${this.host}/working-contracts/${id}`, body);
  }

  finalizeWorkingContract(id: number, body: { end_date: string }): Observable<WorkingContract> {
    return this.http.post<WorkingContract>(`${this.host}/working-contracts/${id}/finalize`, body);
  }

  createWorkingContract(body: WorkingContract) {
    return this.http.post<WorkingContract>(`${this.host}/working-contracts`, body);
  }

  workingContractSimulateRetributionConditions(params: { department_category_ids: number; years_in_bisual: number; when: number }) {
    return this.http.get<{
      data:
        | {
            brute_anual_base_salary: number;
            plus_for_seniority: number;
            flexible_remuneration_monthly_quantity: number;
            health_insurance_plan_id: number | undefined;
            possible_future_early_retirement: boolean;
            possible_future_retirement_plan: boolean;
            start_date: Date;
          }
        | undefined;
    }>(`${this.host}/working-contracts/simulate-retribution-conditions`, { params: params });
  }

  getWorkingContractVariationsForYear(user_id: number, year: number) {
    return this.http.get<{ [key: string]: { expected_hours: number } }>(
      `${this.host}/users/${user_id}/working-contract-variable-conditions/vacation-year/${year}`
    );
  }

  getWorkingContractWorkingContractVariableConditionsNowAndFuture(workingContractId: number, params: any = null) {
    const http_params: HttpParams = this.setParams(params);

    return this.http.get(`${this.host}/working-contracts/${workingContractId}/working-contract-variable-conditions/now-and-future`, {
      params: http_params,
    });
  }

  /**
   * -------------------------------------------------- WORKING CONTRACT YEAR CONDITION --------------------------------------------------
   */
  updateWorkingContractYearCondition(id: number, body: any) {
    return this.http.put<WorkingContractYearCondition>(`${this.host}/working-contract-year-conditions/${id}`, body);
  }

  /**
   * -------------------------------------------------- USERS --------------------------------------------------
   */
  getUsers(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<User>>(`${this.host}/users`, {
      params: http_params,
    });
  }

  getUsersPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<User>>(`${this.host}/users`, {
      params: http_params,
    });
  }

  getUser(id: string, params: any = {}) {
    return this.http.get<User>(`${this.host}/users/${id}`, { params: params });
  }

  getContractUser(id: string, params: any = {}) {
    return this.http.get<WorkingContract>(`${this.host}/users/${id}/current-working-contract`, { params: params });
  }

  createUser(body: User) {
    return this.http.post<User>(`${this.host}/users`, body);
  }

  updateUser(id: string, body: any) {
    return this.http.put<User>(`${this.host}/users/${id}`, body);
  }

  deleteUser(id: number) {
    return this.http.delete<User>(`${this.host}/users/${id}`);
  }

  changeUserPassword(id: string, password: string) {
    return this.http.put<User>(`${this.host}/users/${id}/change-password`, {
      password: password,
    });
  }

  getUserWorkingTimeCategories(id: string, params: any = null) {
    return this.http.get<WorkingTimeCategory[]>(`${this.host}/users/${id}/working-time-categories`, { params: params });
  }

  getUserAssignableWorkingTimeCategories(id: string, params: any = null) {
    return this.http.get<WorkingTimeCategory[]>(`${this.host}/users/${id}/working-time-assignable-categories`, { params: params });
  }

  getUserRegistrableWorkingTimeCategories(id: number, params: HttpQueryParams = {}): Observable<WorkingTimeCategory[]> {
    return this.http.get<WorkingTimeCategory[]>(`${this.host}/users/${id}/working-time-registrable-categories`, { params });
  }

  getTaskWorkingTimeCategories(params: any = null) {
    return this.http.get<WorkingTimeCategory[]>(`${this.host}/working-time-categories/task-time`, {
      params: params,
    });
  }

  autocalcTaskTime(task_id: number, params: any = null) {
    return this.http.get<{ [key: string]: number }>(`${this.host}/product-tasks/${task_id}/task-time-autocalc`, {
      params: params,
    });
  }

  getAllWorkingTimeCategories(params: HttpQueryParams = {}): Observable<WorkingTimeCategory[]> {
    return this.http.get<WorkingTimeCategory[]>(`${this.host}/working-time-categories`, { params: params });
  }

  getWorkingTimeCategoryChildren(id: string, params: any = null) {
    return this.http.get<WorkingTimeCategory[]>(`${this.host}/working-time-categories/${id}/children`, { params: params });
  }

  getEmployeesPlanningByYear(year: number) {
    return this.http.get<User[]>(`${this.host}/users/employees/planning/${year}`).pipe(
      map((users: User[]) => {
        return users.map(u => {
          u.working_contracts = u.working_contracts.map(wc => {
            wc.start_date = new Date(wc.start_date);
            if (wc.end_date != null) wc.end_date = new Date(wc.end_date);
            return wc;
          });
          return u;
        });
      })
    );
  }

  getEmployeesDevelopmentRoadmap(from: Date, to: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToString(from));
    params = params.set('to', this.utils.dateToString(to));
    return this.http.get<DevelopmentRoadmapResponse>(`${this.host}/users/employees/development/roadmap`, { params: params }).pipe(
      map((response: DevelopmentRoadmapResponse) => {
        response.availability = response.availability.map((item: DevelopmentAvailability) => {
          item.from = dayjs(item.from);
          item.to = dayjs(item.to);
          return item;
        });
        return response;
      })
    );
  }

  getAboutMeMeetingRecords(user_id: string, params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<MeetingRecord>>(`${this.host}/users/${user_id}/about-me-meeting-records`, {
      params: http_params,
    });
  }

  getAssistedMeetingRecords(params: Record<string, unknown> | null = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<MeetingRecord>>(`${this.host}/meeting-records/assisted`, {
      params: http_params,
    });
  }

  getCompanyProductMeetingRecords(company_product_id: string, params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<MeetingRecord>>(`${this.host}/company-products/${company_product_id}/meeting-records`, {
      params: http_params,
    });
  }

  /**
   * -------------------------------------------------- WORKING CONTRACT CAREER PLANS --------------------------------------------------
   */
  getUserWorkingContractCareerPlanActiveDetail(user_id: number) {
    return this.http.get<MyCareerPlan>(`${this.host}/users/${user_id}/working-contract-career-plans/active`);
  }

  getUserWorkingContractCareerPlans(user_id: number) {
    return this.http.get<WorkingContractCareerPlan[]>(`${this.host}/users/${user_id}/working-contract-career-plans`);
  }

  cloneWorkingContractCareerPlan(workingContractCareerPlanId: number, date: Date) {
    return this.http.post(`${this.host}/working-contract-career-plans/${workingContractCareerPlanId}/clone`, {
      current_from: this.utils.dateToStringYYYYMMDD(date),
    });
  }

  deleteWorkingContractCareerPlan(id: number) {
    return this.http.delete(`${this.host}/working-contract-career-plans/${id}`);
  }

  updateWorkingContractCareerPlan(
    id: number,
    body: {
      current_from: string | Date;
      current_until: string | Date | null;
      administrators_annotations: string | null;
    }
  ) {
    return this.http.put(`${this.host}/working-contract-career-plans/${id}`, body);
  }

  updateWorkingContractCareerPlanYear(workingContractCareerPlanYearId: number, body: any) {
    return this.http.put(`${this.host}/working-contract-career-plan-years/${workingContractCareerPlanYearId}`, body);
  }

  getUserWorkingContractCareerPlanActiveNextUpgrade(user_id: number) {
    return this.http.get<{
      data: MyCareerPlanNextUpgrade | undefined;
    }>(`${this.host}/users/${user_id}/working-contract-career-plans/active/next-upgrade`);
  }

  getWorkingContractCareerPlanYearsFrom(workingContractCareerPlanId: number) {
    return this.http.get<WorkingContractCareerPlan>(
      `${this.host}/working-contract-career-plans/${workingContractCareerPlanId}/working-contract-career-plan-years`
    );
  }

  getCareerPlanTemplates() {
    return this.http.get<ArrayResponse<WorkingContractTemplateCareerPlan>>(`${this.host}/working-contract-template-career-plans`);
  }

  createWorkingContractCareerPlanFromTemplate(
    user_id: number,
    body: { working_contract_template_career_plan_template_id: number; current_from: Date }
  ) {
    return this.http.post<WorkingContractTemplateCareerPlan>(
      `${this.host}/users/${user_id}/working-contract-career-plans/create-from-template`,
      body
    );
  }

  /**
   *
   * @param params
   * - contract_id: number|null
   * - current_week: string (YYYY-MM-DD)
   * - propagate_company_product_distribution: boolean
   * - propagate_assignation: boolean
   * - to_date: string (YYYY-MM-DD) | null
   * @returns
   */
  copyRoadmapToYear(params: any) {
    return this.http.post(`${this.host}/users/employees/development/roadmap/copy-to-year`, params);
  }

  getEmployeesCompanyProductAssignment(from: Date, to: Date) {
    const from_string = this.utils.dateToStringYYYYMMDD(from);
    const to_string = this.utils.dateToStringYYYYMMDD(to);

    return this.http.get<any>(`${this.host}/users/employees/company-product-assignment/${from_string}/${to_string}`);
  }

  getActiveEmployees(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<User[]>(`${this.host}/users/employees/active`, {
      params: http_params,
    });
  }

  getUserVacations(user_id: number, year: number): Observable<UserVacationsResponse> {
    return this.http.get<UserVacationsResponse>(`${this.host}/users/${user_id}/vacations`, {
      params: { year },
    });
  }

  getVacations(from: Date, to: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToStringYYYYMMDD(from));
    params = params.set('to', this.utils.dateToStringYYYYMMDD(to));

    return this.http.get<EmployeeCalendarRegister[]>(`${this.host}/users/employees/planning/vacations`, { params: params }).pipe(
      map(items => {
        items = items.map(item => {
          item.from_date = new Date(item.from_date);
          item.to_date = new Date(item.to_date);
          return item;
        });
        return items;
      })
    );
  }

  getHolidaysFromActiveWorkingContracts(from: Date, to: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToStringYYYYMMDD(from));
    params = params.set('to', this.utils.dateToStringYYYYMMDD(to));

    return this.http
      .get<Holiday[]>(`${this.host}/users/employees/planning/holidays`, {
        params: params,
      })
      .pipe(
        map(items => {
          items = items.map(item => {
            item.date = new Date(item.date);
            return item;
          });
          return items;
        })
      );
  }

  getBirthdays(from: Date, to: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToStringYYYYMMDD(from));
    params = params.set('to', this.utils.dateToStringYYYYMMDD(to));

    return this.http.get<Birthday[]>(`${this.host}/users/employees/birthdays`, {
      params: params,
    });
  }

  getUsersTodayStatus() {
    return this.http.get<TodayStatusData[]>(`${this.host}/users/employees/today-status`);
  }

  getEmployeeAbsences(user_id: number, from: Date, to: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToStringYYYYMMDD(from));
    params = params.set('to', this.utils.dateToStringYYYYMMDD(to));

    return this.http.get<{
      holidays: Holiday[];
      employee_calendar_registers: EmployeeCalendarRegister[];
    }>(`${this.host}/users/${user_id}/absences`, { params: params });
  }

  getAllEmployeeAbsencesThatAffectMe(from: Date, to: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToStringYYYYMMDD(from));
    params = params.set('to', this.utils.dateToStringYYYYMMDD(to));

    return this.http.get<{
      my_holidays: Holiday[];
      employee_calendar_registers: EmployeeCalendarRegister[];
    }>(`${this.host}/users/employees/absences`, { params: params });
  }

  getAllDayAndNoWorkingTimeAbsencesFromWorkers(
    from: Date,
    to: Date
  ): Observable<{
    employee_calendar_registers: EmployeeCalendarRegister[];
  }> {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToStringYYYYMMDD(from));
    params = params.set('to', this.utils.dateToStringYYYYMMDD(to));

    return this.http
      .get<{
        employee_calendar_registers: EmployeeCalendarRegister[];
      }>(`${this.host}/users/employees/absences/all-day-and-no-working-time`, {
        params: params,
      })
      .pipe(
        map(data => {
          data.employee_calendar_registers = data.employee_calendar_registers.map(item => {
            item.from_date = new Date(item.from_date);
            item.to_date = new Date(item.to_date);
            return item;
          });
          return data;
        })
      );
  }

  addCompanyProductToFavorite(user_id: number, company_product_id: number) {
    return this.http.post(`${this.host}/users/${user_id}/company-products/${company_product_id}/favorite`, {});
  }

  removeCompanyProductFromFavorite(user_id: number, company_product_id: number) {
    return this.http.delete(`${this.host}/users/${user_id}/company-products/${company_product_id}/favorite`);
  }

  getTimeWithoutRegister(user_id: number, date: Date | null) {
    return this.http.get<any>(`${this.host}/users/${user_id}/time-without-register`, {
      params: date ? { date: dayjs(date).format('YYYY-MM-DD') } : {},
    });
  }

  getEmployeesWorkingContractYearConditions(year: string) {
    return this.http.get<
      {
        user: User;
        working_contract_year_condition: WorkingContractYearCondition | undefined;
      }[]
    >(`${this.host}/users/employees/working-contract-year-conditions`, {
      params: { year: year },
    });
  }

  getUserWorkingContractYearConditions(user_id: number, params: any = {}) {
    return this.http.get<WorkingContractYearCondition[]>(`${this.host}/users/${user_id}/working-contract-year-conditions`, {
      params: params,
    });
  }

  /**
   * -------------------------------------------------- ROLES --------------------------------------------------
   */
  getRoles() {
    return this.http.get<Role[]>(`${this.host}/roles`);
  }

  /**
   * -------------------------------------------------- DEPARTMENT CATEGORIES --------------------------------------------------
   */
  getDepartmentCategories(params: any = {}) {
    return this.http.get<ArrayResponse<DepartmentCategory>>(`${this.host}/department-categories`, { params: params });
  }

  getDepartmentCategory(id: string, params: any = {}) {
    return this.http.get<DepartmentCategory>(`${this.host}/department-categories/${id}`, { params: params });
  }

  getDepartmentCategoriesPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<DepartmentCategory>>(`${this.host}/department-categories`, { params: http_params });
  }

  createDepartmentCategory(body: DepartmentCategory) {
    return this.http.post<DepartmentCategory>(`${this.host}/department-categories`, body);
  }

  updateDepartmentCategory(id: string, body: any) {
    return this.http.put<DepartmentCategory>(`${this.host}/department-categories/${id}`, body);
  }

  deleteDepartmentCategory(id: number) {
    return this.http.delete<DepartmentCategory>(`${this.host}/department-categories/${id}`);
  }

  /**
   * -------------------------------------------------- DEPARTMENTS --------------------------------------------------
   */

  getDepartments(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<Department>>(`${this.host}/departments`, { params: http_params });
  }

  getDepartment(id: string) {
    return this.http.get<Department>(`${this.host}/departments/${id}`);
  }

  getDepartmentsPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<Department>>(`${this.host}/departments`, { params: http_params });
  }

  updateDepartment(id: string, body: any) {
    return this.http.put<Department>(`${this.host}/departments/${id}`, body);
  }

  createDepartment(body: Department) {
    return this.http.post<Department>(`${this.host}/departments`, body);
  }
  /**
   * -------------------------------------------------- COMPANY_PRODUCTS --------------------------------------------------
   */
  getCompanyProductsPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<CompanyProduct>>(`${this.host}/company-products`, {
      params: http_params,
    });
  }

  getCompanyProducts(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<CompanyProduct>>(`${this.host}/company-products`, {
      params: http_params,
    });
  }

  getCompanyProduct(id: string, query: any = {}) {
    return this.http.get<CompanyProduct>(`${this.host}/company-products/${id}`, {
      params: query,
    });
  }

  downloadCompanyProductDailyAnonymizedDump(company_product_id: number) {
    return this.http.get(`${this.host}/company-products/${company_product_id}/daily-anonymized-dump`, {
      responseType: 'blob',
    });
  }

  updateCompanyProduct(id: number, body: Partial<CompanyProduct>) {
    return this.http.put<CompanyProduct>(`${this.host}/company-products/${id}`, body);
  }

  updateCompanyProductBisualInternalTeamSlackChannel(
    id: number,
    body: {
      internal_team_messaging_conversation_id: number;
    }
  ) {
    return this.http.put<CompanyProduct>(`${this.host}/company-products/${id}/bisual-internal-team-slack-channel`, body);
  }

  listCompanyProductBisualInternalTeamSlackChannels(id: number) {
    return this.http.get<{
      data: Array<{ conversation_id: string; name: string; kind: string; provider: string; external_tenant_id: string }>;
    }>(`${this.host}/company-products/${id}/bisual-internal-team-slack-channels`);
  }

  getCompanyProductStatusMonitors(company_product_id: number, query: Record<string, string | number | boolean> = {}) {
    return this.http.get<ArrayResponse<CompanyProductStatusMonitor>>(
      `${this.host}/company-products/${company_product_id}/company-product-status-monitors`,
      { params: query }
    );
  }

  syncCompanyProductStatusMonitorNotifiables(id: number, body: { user_ids?: number[]; messaging_conversation_ids?: number[] }) {
    return this.http.put<CompanyProductStatusMonitor>(`${this.host}/company-product-status-monitors/${id}/notifiables`, body);
  }

  getCompanyMetrics(company_product_id: number, date: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('date', this.utils.dateToStringYYYYMMDD(date));
    return this.http.get<CompanyMetricsResponse>(`${this.host}/company-products/${company_product_id}/company-metrics`, {
      params: params,
    });
  }

  getActiveCompanyObjective(company_product_id: number, date: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('date', this.utils.dateToStringYYYYMMDD(date));
    return this.http
      .get<{
        active_company_objective: ActiveCompanyObjective | null;
      }>(`${this.host}/company-products/${company_product_id}/active-company-objective`, { params })
      .pipe(map(response => response.active_company_objective));
  }

  getCompanyMetricIngestHelp(
    company_product_id: number,
    params: {
      company_metric_slug: string;
      company_metric_title: string;
      company_metric_relatable: 'company' | 'product';
      unit?: string | null;
    }
  ) {
    let http_params = new HttpParams()
      .set('company_metric_slug', params.company_metric_slug)
      .set('company_metric_title', params.company_metric_title)
      .set('company_metric_relatable', params.company_metric_relatable);

    if (params.unit != null && params.unit !== '') {
      http_params = http_params.set('unit', params.unit);
    }

    return this.http.get<CompanyMetricIngestHelpResponse>(
      `${this.host}/company-products/${company_product_id}/company-metrics/ingest-help`,
      { params: http_params }
    );
  }

  getMyActiveCompanyObjectives(date: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('date', this.utils.dateToStringYYYYMMDD(date));
    return this.http.get<ActiveCompanyObjective[]>(`${this.host}/me/active-company-objectives`, {
      params: params,
    });
  }

  getOkrManagement(company_product_id: number, period_id: number | null, view: 'company' | 'product') {
    let params: HttpParams = new HttpParams();
    params = params.set('view', view);
    if (period_id !== null) {
      params = params.set('company_objective_period_id', String(period_id));
    }

    return this.http.get<OkrManagementTree>(`${this.host}/company-products/${company_product_id}/okr-management`, { params });
  }

  getOkrMetrics(company_product_id: number, search = '') {
    let params: HttpParams = new HttpParams();
    if (search !== '') {
      params = params.set('search', search);
    }

    return this.http.get<{ company_metrics: OkrMetricOption[] }>(`${this.host}/company-products/${company_product_id}/okr-metrics`, {
      params,
    });
  }

  storeCompanyObjectivePeriod(body: { company_id: number; start_date: string; end_date: string }) {
    return this.http.post(`${this.host}/company-objective-periods`, body);
  }

  updateCompanyObjectivePeriod(id: number, body: { start_date?: string; end_date?: string }) {
    return this.http.put(`${this.host}/company-objective-periods/${id}`, body);
  }

  destroyCompanyObjectivePeriod(id: number) {
    return this.http.delete(`${this.host}/company-objective-periods/${id}`);
  }

  storeCompanyObjective(body: {
    company_objective_period_id: number;
    title: string;
    relatable_type: 'company' | 'company_product';
    relatable_id: number;
  }) {
    return this.http.post(`${this.host}/company-objectives`, body, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true'),
    });
  }

  updateCompanyObjective(id: number, body: { title: string }) {
    return this.http.put(`${this.host}/company-objectives/${id}`, body, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true'),
    });
  }

  destroyCompanyObjective(id: number) {
    return this.http.delete(`${this.host}/company-objectives/${id}`);
  }

  storeCompanyObjectiveKeyResult(body: Record<string, unknown>) {
    return this.http.post(`${this.host}/company-objective-key-results`, body, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true'),
    });
  }

  updateCompanyObjectiveKeyResult(id: number, body: Record<string, unknown>) {
    return this.http.put(`${this.host}/company-objective-key-results/${id}`, body, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true'),
    });
  }

  updateCompanyMetricVariableCondition(id: number, body: Record<string, unknown>) {
    return this.http.put(`${this.host}/company-metric-variable-conditions/${id}`, body);
  }

  forkCompanyMetricVariableCondition(id: number, body: Record<string, unknown>) {
    return this.http.post(`${this.host}/company-metric-variable-conditions/${id}/fork-thresholds`, body);
  }

  destroyCompanyObjectiveKeyResult(id: number) {
    return this.http.delete(`${this.host}/company-objective-key-results/${id}`);
  }

  getUserCompanyProducts(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<CompanyProduct>>(`${this.host}/me/company-products`, {
      params: http_params,
    });
  }

  getUserCompanyProductsActiveRoles(user_id: any, params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<
      {
        company_product_id: number;
        company_product_name: string;
        department_category_id: number;
        slug: string;
      }[]
    >(`${this.host}/company-products/${user_id}/active-roles`, { params: http_params });
  }

  getBisualProductionTeam(company_product_id: string) {
    return this.http.get<CompanyProductUserMember[]>(`${this.host}/company-products/${company_product_id}/users/bisual-production-team`);
  }

  getBisualProductionTeamNowAndFuture(company_product_id: string, params: any = {}) {
    return this.http
      .get<
        CompanyProductUserMember[]
      >(`${this.host}/company-products/${company_product_id}/users/bisual-production-team/now-and-future`, { params: params })
      .pipe(
        map((data: CompanyProductUserMember[]) => {
          for (const row of data) {
            row.start_date = new Date(row.start_date);
            if (row.end_date != null) row.end_date = new Date(row.end_date);
          }
          return data;
        })
      );
  }

  getCompanyProductActiveProductionTeam(company_product_id: string) {
    return this.http.get<{
      bisual_users: CompanyProductUserMember[];
      company_users: User[];
    }>(`${this.host}/company-products/${company_product_id}/users/production-team`);
  }

  getActiveCompanyProductMembers(company_product_id: string, params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<CompanyProductUserMember[]>(`${this.host}/company-products/${company_product_id}/users/active`, {
      params: http_params,
    });
  }

  getActiveCompanyProductMembersWithBusiness(company_product_id: string) {
    return this.http.get<{
      bisual_users: CompanyProductUserMember[];
      company_users: User[];
      account_manager_users: User[];
    }>(`${this.host}/company-products/${company_product_id}/users/active-with-business`);
  }

  bulkMembers(company_product_id: number, data: BulkDataStructureRequest<CompanyProductUserMember>) {
    return this.http.post<BulkDataStructureResponse<CompanyProductUserMember>>(
      `${this.host}/company-products/${company_product_id}/users/bisual-production-team/bulk`,
      data
    );
  }

  getCompanyProductApplications(company_product_id: string, params: any = null) {
    const http_params: HttpParams = this.setParams(params || {});
    return this.http.get<Application[]>(`${this.host}/company-products/${company_product_id}/applications`, {
      params: http_params,
    });
  }

  getCompanyProductApplicationEnvironments(company_product_id: string) {
    return this.http.get<ApplicationEnvironment[]>(`${this.host}/company-products/${company_product_id}/application-environments`);
  }

  getCompanyProductVacations(company_product_id: string, from: Date, to: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToStringYYYYMMDD(from));
    params = params.set('to', this.utils.dateToStringYYYYMMDD(to));

    return this.http
      .get<EmployeeCalendarRegister[]>(`${this.host}/company-products/${company_product_id}/vacations`, { params: params })
      .pipe(
        map(items => {
          items = items.map(item => {
            item.from_date = new Date(item.from_date);
            item.to_date = new Date(item.to_date);
            return item;
          });
          return items;
        })
      );
  }

  getCompanyProductHolidays(company_product_id: string, from: Date, to: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToStringYYYYMMDD(from));
    params = params.set('to', this.utils.dateToStringYYYYMMDD(to));

    return this.http
      .get<Holiday[]>(`${this.host}/company-products/${company_product_id}/holidays`, {
        params: params,
      })
      .pipe(
        map(items => {
          items = items.map(item => {
            item.date = new Date(item.date);
            return item;
          });
          return items;
        })
      );
  }

  getCompanyProductGuardianContracts(company_product_id: string, from: Date, to: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToStringYYYYMMDD(from));
    params = params.set('to', this.utils.dateToStringYYYYMMDD(to));
    params = params.set('type', 'guardian');
    return this.http
      .get<Contract[]>(`${this.host}/company-products/${company_product_id}/contracts`, {
        params: params,
      })
      .pipe(
        map((contracts: Contract[]) => {
          for (const contract of contracts) {
            contract.starts_at = new Date(contract.starts_at);
            contract.ends_at = new Date(contract.ends_at);
          }
          return contracts;
        })
      );
  }

  assignCompanyProductGuardianScheduledWeek(company_product_id: string, user_id: string, dateYYYYMMDD: string) {
    return this.http.post<GuardianScheduledWeek>(`${this.host}/company-products/${company_product_id}/guardian-scheduled-weeks`, {
      user_id: user_id,
      date: dateYYYYMMDD,
    });
  }

  getCompanyProductCompanyProductTeams(company_product_id: string, params: any = {}) {
    return this.http.get<CompanyProductTeam[]>(`${this.host}/company-products/${company_product_id}/company-product-teams`, {
      params: params,
    });
  }

  downloadCompanyProductXlsxTaskCreationTemplate(company_product_id: number) {
    return this.http.get(`${this.host}/company-products/${company_product_id}/product-tasks/download-xlsx-task-creation-template`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  getCompanyProductTeamFromCompanyProduct(company_product_id: string) {
    return this.http.get<CompanyProductTeam[]>(`${this.host}/company-products/${company_product_id}/company-product-teams`);
  }

  /**
   * -------------------------------------------------- COMPANY_PRODUCT DEFAULT TIME DISTRIBUTION --------------------------------------------------
   */
  getCompanyProductDefaultTimeDistributions(company_product_id: string): Observable<CompanyProductDefaultTimeDistribution[]> {
    return this.http.get<CompanyProductDefaultTimeDistribution[]>(
      `${this.host}/company-products/${company_product_id}/company-product-default-time-distributions/now-and-future`
    );
  }

  deleteCompanyProductDefaultTimeDistribution(
    company_product_id: string,
    companyProductDefaultTimeDistributionId: number
  ): Observable<number> {
    return this.http.delete<number>(
      `${this.host}/company-products/${company_product_id}/company-product-default-time-distributions/${companyProductDefaultTimeDistributionId}`
    );
  }

  cloneCompanyProductDefaultTimeDistribution(
    company_product_id: string,
    companyProductDefaultTimeDistributionId: number,
    new_start_date: string
  ): Observable<void> {
    return this.http.post<void>(
      `${this.host}/company-products/${company_product_id}/company-product-default-time-distributions/${companyProductDefaultTimeDistributionId}/clone`,
      { new_start_date }
    );
  }

  getCompanyProductDefaultTimeDistribution(company_product_id: string, companyProductDefaultTimeDistributionId: number) {
    return this.http.get<CompanyProductDefaultTimeDistribution>(
      `${this.host}/company-products/${company_product_id}/company-product-default-time-distributions/${companyProductDefaultTimeDistributionId}`
    );
  }

  getCurrentDefaultTimeDistributionTaskTimeForCompanyProductPhase(company_product_id: number, company_product_phase_id: number) {
    return this.http.get<CompanyProductDefaultTimeDistributionDistributable[]>(
      `${this.host}/company-products/${company_product_id}/company-product-default-time-distributions/${company_product_phase_id}/current/task-time`
    );
  }

  updateCompanyProductDefaultTimeDistribution(company_product_id: string, body: any, companyProductDefaultTimeDistributionId: number) {
    return this.http.put<CompanyProductDefaultTimeDistribution>(
      `${this.host}/company-products/${company_product_id}/company-product-default-time-distributions/${companyProductDefaultTimeDistributionId}`,
      body
    );
  }

  addPhaseToDefaultTimeDistribution(companyProductId: number, distributionId: number, phaseId: number) {
    return this.http.post<CompanyProductDefaultTimeDistributionDistributable>(
      `${this.host}/company-products/${companyProductId}/company-product-default-time-distributions/${distributionId}/phases/${phaseId}`,
      {}
    );
  }

  removePhaseFromDefaultTimeDistribution(companyProductId: number, distributionId: number, phaseId: number): Observable<any> {
    return this.http.delete(
      `${this.host}/company-products/${companyProductId}/company-product-default-time-distributions/${distributionId}/phases/${phaseId}`
    );
  }

  addCategoryToDefaultTimeDistribution(
    companyProductId: number,
    distributionId: number,
    category_slug: string,
    parent_distributable_id: number | null
  ): Observable<any> {
    return this.http.post<any>(
      `${this.host}/company-products/${companyProductId}/company-product-default-time-distributions/${distributionId}/categories`,
      {
        category_slug,
        parent_distributable_id,
      }
    );
  }

  removeCategoryFromDefaultTimeDistribution(companyProductId: number, distributionId: number, distributableId: number): Observable<any> {
    return this.http.delete(
      `${this.host}/company-products/${companyProductId}/company-product-default-time-distributions/${distributionId}/categories/${distributableId}`
    );
  }

  /**
   * -------------------------------------------------- COMPANY_PRODUCT DEPLOYS --------------------------------------------------
   */
  getCompanyProductDeploys(company_product_id: string, params: any = null) {
    const http_params: HttpParams = this.setParams(params || {});
    return this.http.get<ArrayResponse<CompanyProductDeploy>>(
      `${this.host}/company-products/${company_product_id}/company-product-deploys`,
      {
        params: http_params,
      }
    );
  }

  getCompanyProductDeploysCollection(company_product_id: string, params: any = null) {
    const http_params: HttpParams = this.setParams(params || {});
    return this.http.get<CompanyProductDeploy[]>(`${this.host}/company-products/${company_product_id}/company-product-deploys`, {
      params: http_params,
    });
  }

  getCompanyProductDeploy(deploy_id: string, params: any = null) {
    const http_params: HttpParams = this.setParams(params || {});
    return this.http.get<CompanyProductDeploy>(`${this.host}/company-product-deploys/${deploy_id}`, {
      params: http_params,
    });
  }

  getLatestFrontendVersion(environment: 'production' | 'staging' | 'development' | 'other') {
    return this.http.get<{
      version: string | null;
      environment: string;
      is_production: boolean;
    }>(`${this.host}/company-product-deploys/latest-frontend-version`, {
      params: this.setParams({ environment }),
    });
  }

  /**
   * -------------------------------------------------- COMPANY_PRODUCT DEPLOY CONFIGURATIONS --------------------------------------------------
   */
  getCompanyProductDeployConfigurations(companyProductId: string, params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<CompanyProductDeployConfiguration[]>(
      `${this.host}/company-products/${companyProductId}/company-product-deploy-configurations`,
      {
        params: http_params,
      }
    );
  }

  createCompanyProductDeployConfiguration(companyProductId: string, body: any) {
    return this.http.post<CompanyProductDeployConfiguration>(`${this.host}/company-product-deploy-configurations`, body);
  }

  updateCompanyProductDeployConfiguration(configuration_id: string, body: any) {
    return this.http.put<CompanyProductDeployConfiguration>(`${this.host}/company-product-deploy-configurations/${configuration_id}`, body);
  }

  deleteCompanyProductDeployConfiguration(configuration_id: string) {
    return this.http.delete(`${this.host}/company-product-deploy-configurations/${configuration_id}`);
  }

  /**
   * -------------------------------------------------- COMPANY_PRODUCT USER MEMBER ROLE --------------------------------------------------
   */
  getCompanyProductUserMemberRoles() {
    return this.http.get<ArrayResponse<CompanyProductUserMemberRole>>(`${this.host}/company-product-user-member-roles`);
  }

  /**
   * -------------------------------------------------- GUARDIAN SCHEDULED WEEKS --------------------------------------------------
   */
  getGuardianScheduledWeeks(body: any) {
    return this.http
      .get<GuardianScheduledWeek[]>(`${this.host}/guardian-scheduled-weeks`, {
        params: body,
      })
      .pipe(
        map((gsws: GuardianScheduledWeek[]) => {
          gsws.forEach(gsw => {
            gsw.start_week = new Date(gsw.start_week);
            gsw.to_week = new Date(gsw.to_week);
          });
          return gsws;
        })
      );
  }

  deleteGuardianScheduledWeek(id: string) {
    return this.http.delete<GuardianScheduledWeek>(`${this.host}/guardian-scheduled-weeks/${id}`);
  }

  /**
   * -------------------------------------------------- COMPANY_PRODUCT SERVICE --------------------------------------------------
   */
  getCompanyProductServices(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<CompanyProductService[]>(`${this.host}/company-product-services`, {
      params: http_params,
    });
  }

  /**
   * -------------------------------------------------- COMPANY_PRODUCT PHASE STAGE --------------------------------------------------
   */
  getCompanyProductPhaseStages() {
    return this.http.get<CompanyProductPhaseStage[]>(`${this.host}/company-product-phase-stages`);
  }

  getCompanyProductPhaseTypes(): Observable<ArrayResponse<CompanyProductPhaseType>> {
    return this.http.get<ArrayResponse<CompanyProductPhaseType>>(`${this.host}/company-product-phase-types`);
  }

  /**
   * -------------------------------------------------- COMPANY_PRODUCT PHASES --------------------------------------------------
   * */

  getCompanyProductPhasesPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http
      .get<ArrayResponse<CompanyProductPhase>>(`${this.host}/company-product-phases`, {
        params: http_params,
      })
      .pipe(
        map(data => {
          data.data = data.data.map((pp: CompanyProductPhase) => {
            if (pp.contract) {
              pp.contract.starts_at = new Date(pp.contract.starts_at);
              pp.contract.ends_at = new Date(pp.contract.ends_at);
            }
            return pp;
          });
          return data;
        })
      );
  }

  getCompanyProductPhases(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<CompanyProductPhase>>(`${this.host}/company-product-phases`, { params: http_params });
  }

  getCompanyProductPhase(id: number, params: any = {}) {
    return this.http.get<CompanyProductPhase>(`${this.host}/company-product-phases/${id}`, { params });
  }

  requestCompanyProductPhaseRoadmapExcelByEmail(id: number, params: HttpQueryParams = {}): Observable<LongTask> {
    return this.http.get<LongTask>(`${this.host}/company-product-phases/${id}/download-roadmap-as-excel`, { params });
  }

  updateCompanyProductPhase(id: number, body: any) {
    return this.http.put<CompanyProductPhase>(`${this.host}/company-product-phases/${id}`, body);
  }

  getCompanyProductPhaseBacklog(
    company_product_phase_id: number,
    params: {
      from: Date | string | undefined;
      to: Date | string | undefined;
      min_order?: number | undefined;
      max_order?: number | undefined;
      roadmap?: boolean | 0 | 1;
      totals?: 'all' | 'boards' | 'tasks';
      prediction_state?: string;
      exclude_archived?: number;
    }
  ) {
    return this.http.get<CompanyProductPhaseBacklogData>(`${this.host}/company-product-phases/${company_product_phase_id}/backlog`, {
      params: params as any,
    });
  }

  getCompanyProductPhaseUserPermissions(company_product_phase_id: number): Observable<CompanyProductPhaseUserPermissions> {
    return this.http.get<CompanyProductPhaseUserPermissions>(
      `${this.host}/company-product-phases/${company_product_phase_id}/user-permissions`
    );
  }

  getCompanyProductUserPermissions(company_product_id: number | string): Observable<CompanyProductUserPermissions> {
    return this.http.get<CompanyProductUserPermissions>(`${this.host}/company-products/${company_product_id}/user-permissions`);
  }

  getCompanyProductEpics(company_product_phase_id: number) {
    return this.http.get<CompanyProductEpic[]>(`${this.host}/company-product-phases/${company_product_phase_id}/company-product-epics`);
  }

  changePhaseTasksOrder(company_product_phase_id: number, data: { [key: number]: number }) {
    return this.http.put<{ [key: number]: number }>(
      `${this.host}/company-product-phases/${company_product_phase_id}/product-tasks/change-phase-order`,
      data,
      {
        headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
      }
    );
  }

  /**
   * --------------------------------- COMPANY_PRODUCT PHASES TASK TIME AUTOCALC SETTINGS ---------------------------------
   * */

  getCompanyProductPhaseTaskTimeAutocalcSettings(params: any = {}) {
    return this.http.get<ArrayResponse<CompanyProductPhaseTaskTimeAutocalcSetting>>(
      `${this.host}/company-product-phase-task-time-autocalc-settings`,
      {
        params: params,
      }
    );
  }

  updateCompanyProductPhaseTaskTimeAutocalcSettings(id: number, body: CompanyProductPhaseTaskTimeAutocalcSetting) {
    return this.http.put<CompanyProductPhaseTaskTimeAutocalcSetting>(
      `${this.host}/company-product-phase-task-time-autocalc-settings/${id}`,
      body
    );
  }

  updateCompanyProductPhaseTaskTimeAutocalcSettingBulk(body: CompanyProductPhaseTaskTimeAutocalcSetting[]) {
    return this.http.put<CompanyProductPhaseTaskTimeAutocalcSetting[]>(
      `${this.host}/company-product-phase-task-time-autocalc-settings/bulk`,
      body
    );
  }

  /**
   * -------------------------------------------------- LOCATIONS --------------------------------------------------
   */
  createLocation(body: ManageLocationBody): Observable<Location> {
    return this.http.post<Location>(`${this.host}/locations`, body);
  }

  updateLocation(location_id: number, body: ManageLocationBody): Observable<Location> {
    return this.http.put<Location>(`${this.host}/locations/${location_id}`, body);
  }

  deleteLocation(location_id: number): Observable<Location> {
    return this.http.delete<Location>(`${this.host}/locations/${location_id}`);
  }

  getLocations(params: HttpQueryParams = {}): Observable<ArrayResponse<Location>> {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<Location>>(`${this.host}/locations`, { params: http_params });
  }

  getLocationSuggestions(
    params: HttpQueryParams = {}
  ): Observable<ArrayResponse<LocationSuggestion> & { show_icloud_private_relay_warning?: boolean }> {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<LocationSuggestion> & { show_icloud_private_relay_warning?: boolean }>(
      `${this.host}/locations/suggestions`,
      { params: http_params }
    );
  }

  getLocationIps(params: HttpQueryParams = {}): Observable<ArrayResponse<LocationIp>> {
    const http_params: HttpParams = this.setParams({ with: 'location', ...params });
    return this.http.get<ArrayResponse<LocationIp>>(`${this.host}/location-ips`, { params: http_params });
  }

  /**
   * -------------------------------------------------- HOSTINGS --------------------------------------------------
   */
  getHostings(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<Hosting[]>(`${this.host}/hostings`, {
      params: http_params,
    });
  }

  getHostingsPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<Hosting>>(`${this.host}/hostings`, {
      params: http_params,
    });
  }

  getHosting(id: string) {
    return this.http.get<Hosting>(`${this.host}/hostings/${id}`);
  }

  getHostingComplete(id: string) {
    return this.http.get<Hosting>(`${this.host}/hostings/${id}/complete`);
  }

  createHosting(request: any) {
    return this.http.post<Hosting>(`${this.host}/hostings`, request);
  }

  updateHosting(id: number, request: any) {
    return this.http.put<Hosting>(`${this.host}/hostings/${id}`, request);
  }

  cancelHosting(id: number) {
    return this.http.delete<Hosting>(`${this.host}/hostings/${id}/cancel`);
  }

  deleteHosting(id: number) {
    return this.http.delete<Hosting>(`${this.host}/hostings/${id}/delete`);
  }

  /**
   * -------------------------------------------------- HETZNER --------------------------------------------------
   */
  getHetznerServerTypes() {
    return this.http.get<HetznerServerType[]>(`${this.host}/hetzner/server-types`);
  }

  getHetznerImages() {
    return this.http.get<HetznerImage[]>(`${this.host}/hetzner/images`);
  }

  getHetznerLocations() {
    return this.http.get<HetznerLocation[]>(`${this.host}/hetzner/locations`);
  }

  startServerHetzner(hetzner_id: string) {
    return this.http.post<any>(`${this.host}/hetzner/${hetzner_id}/start-server`, {});
  }

  stopServerHetzner(hetzner_id: string) {
    return this.http.post<any>(`${this.host}/hetzner/${hetzner_id}/stop-server`, {});
  }

  restartServerHetzner(hetzner_id: string) {
    return this.http.post<any>(`${this.host}/hetzner/${hetzner_id}/restart-server`, {});
  }

  enableBackupsHetzner(hetzner_id: string) {
    return this.http.post<any>(`${this.host}/hetzner/${hetzner_id}/enable-backups`, {});
  }

  disableBackupsHetzner(hetzner_id: string) {
    return this.http.post<any>(`${this.host}/hetzner/${hetzner_id}/disable-backups`, {});
  }

  resetRootPasswordHetzner(hetzner_id: string) {
    return this.http.post<Credential>(`${this.host}/hetzner/${hetzner_id}/reset-root-password`, {});
  }

  changeServerTypeHetzner(hetzner_id: string, upgrade_disk: boolean, server_type: string) {
    return this.http.post<any>(`${this.host}/hetzner/${hetzner_id}/change-server-type`, {
      upgrade_disk: upgrade_disk,
      server_type: server_type,
    });
  }

  /**
   * CREDENTIAL
   */
  createCredential(body: Credential) {
    return this.http.post<Credential>(`${this.host}/credentials`, body);
  }

  updateCredential(id: number, body: Credential) {
    return this.http.put<Credential>(`${this.host}/credentials/${id}`, body);
  }

  deleteCredential(id: number) {
    return this.http.delete<Credential>(`${this.host}/credentials/${id}`);
  }

  /**
   * -------------------------------------------------- DOMAINS --------------------------------------------------
   */
  getDomains(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<Domain[]>(`${this.host}/domains`, {
      params: http_params,
    });
  }

  getDomainsPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<Domain>>(`${this.host}/domains`, {
      params: http_params,
    });
  }

  getDomain(id: string) {
    return this.http.get<Domain>(`${this.host}/domains/${id}`);
  }

  createDomain(request: any) {
    return this.http.post<Domain>(`${this.host}/domains`, request);
  }

  updateDomain(id: number, request: any) {
    return this.http.put<Domain>(`${this.host}/domains/${id}`, request);
  }

  getDomainComplete(id: string) {
    return this.http.get<Domain>(`${this.host}/domains/${id}/complete`);
  }

  cancelDomain(id: number) {
    return this.http.delete<Domain>(`${this.host}/domains/${id}/cancel`);
  }

  connectDns(id: number) {
    return this.http.put<Domain>(`${this.host}/domains/${id}/connect-dns`, {});
  }

  changeGodaddyDns(id: number, nameservers: string[]) {
    return this.http.put<Domain>(`${this.host}/domains/${id}/godaddy/change-dns`, { name_servers: nameservers });
  }

  createCloudflareDns(id: number, dns_register: CloudflareZoneDns) {
    return this.http.post<Domain>(`${this.host}/domains/${id}/cloudflare/dns`, dns_register);
  }

  updateCloudflareDns(id: number, dns_register: CloudflareZoneDns) {
    return this.http.put<Domain>(`${this.host}/domains/${id}/cloudflare/dns/${dns_register.id}`, dns_register);
  }

  deleteCloudflareDns(id: number, dns_register: CloudflareZoneDns) {
    return this.http.delete<Domain>(`${this.host}/domains/${id}/cloudflare/dns/${dns_register.id}`);
  }

  /**
   * -------------------------------------------------- GODADDY --------------------------------------------------
   */
  getGodaddyAgreements(tld: string) {
    let params: HttpParams = new HttpParams();
    params = params.set('tld', tld);
    return this.http.get<any>(`${this.host}/godaddy/agreements`, {
      params: params,
    });
  }

  checkGodaddyDomainAvailability(domain: string) {
    let params: HttpParams = new HttpParams();
    params = params.set('domain', domain);
    return this.http.get<any>(`${this.host}/godaddy/check-domain-availability`, { params: params });
  }

  /**
   * -------------------------------------------------- BUSINESS MAIL --------------------------------------------------
   */
  getBusinessMails(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<BusinessMail[]>(`${this.host}/business-mails`, {
      params: http_params,
    });
  }

  getBusinessMailsPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<BusinessMail>>(`${this.host}/business-mails`, { params: http_params });
  }

  getBusinessMail(id: string) {
    return this.http.get<BusinessMail>(`${this.host}/business-mails/${id}`);
  }

  createBusinessMail(request: any) {
    return this.http.post<BusinessMail>(`${this.host}/business-mails`, request);
  }

  updateBusinessMail(id: number, request: any) {
    return this.http.put<BusinessMail>(`${this.host}/business-mails/${id}`, request);
  }

  getBusinessMailComplete(id: string) {
    return this.http.get<BusinessMail>(`${this.host}/business-mails/${id}/complete`);
  }

  cancelBusinessMail(id: number) {
    return this.http.delete<BusinessMail>(`${this.host}/business-mails/${id}/cancel`);
  }

  /**
   * -------------------------------------------------- OVH --------------------------------------------------
   */
  createOvhCart() {
    return this.http.get<OvhCart>(`${this.host}/ovh/create-cart`);
  }

  getOvhExchangeOffers(cart_id: string) {
    return this.http.get<OvhGenericProduct[]>(`${this.host}/ovh/${cart_id}/exchange/offers`);
  }

  getOvhExchangeOptions(cart_id: string, planCode: string) {
    return this.http.get<OvhGenericProductOption[]>(`${this.host}/ovh/${cart_id}/exchange/${planCode}/options`);
  }

  updateOvhExchangeServer(ovh_id: string, data: any) {
    return this.http.put<OvhExchangeServer>(`${this.host}/ovh/exchange/${ovh_id}`, data);
  }

  updateOvhExchangeAccount(ovh_id: string, account: string, data: any) {
    return this.http.put<OvhExchangeServerAccount>(`${this.host}/ovh/exchange/${ovh_id}/${account}`, data);
  }

  /**
   * -------------------------------------------------- UTILS --------------------------------------------------
   */
  getRegex() {
    return this.http.get<any>(`${this.host}/utils/regex-patterns`);
  }

  /**
   * -------------------------------------------------- COMPANIES --------------------------------------------------
   */
  getCompanies(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<Company>>(`${this.host}/companies`, {
      params: http_params,
    });
  }

  getCompaniesPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<Company>>(`${this.host}/companies`, {
      params: http_params,
    });
  }

  getCompany(id: string, params: any = {}) {
    return this.http.get<Company>(`${this.host}/companies/${id}`, {
      params: params,
    });
  }

  getBisualCompany() {
    return this.http.get<Company>(`${this.host}/companies/bisual`);
  }

  createCompany(body: Company) {
    return this.http.post<Company>(`${this.host}/companies`, body);
  }

  updateCompany(id: string, body: any) {
    return this.http.put<Company>(`${this.host}/companies/${id}`, body);
  }

  deleteCompany(id: number) {
    return this.http.delete<Company>(`${this.host}/companies/${id}`);
  }

  getUserPartnerContracts(user_id: number | string) {
    const http_params: HttpParams = this.setParams({
      user_id,
      with: 'partner_contract_variable_conditions.departments',
      append: 'partner_contract_variable_conditions.is_active',
      order_by: 'start_date:desc',
    });
    return this.http.get<ArrayResponse<PartnerContract>>(`${this.host}/partner-contracts`, { params: http_params });
  }

  createUserPartnerContract(
    user_id: number | string,
    body: {
      start_date: string;
      end_date?: string | null;
      department_ids?: number[];
    }
  ) {
    return this.http.post<PartnerContract>(`${this.host}/partner-contracts`, { ...body, user_id });
  }

  updateUserPartnerContract(
    user_id: number | string,
    contract_id: number | string,
    body: Partial<{ start_date: string; end_date: string | null }>
  ) {
    return this.http.put<PartnerContract>(`${this.host}/partner-contracts/${contract_id}`, body);
  }

  deleteUserPartnerContract(user_id: number | string, contract_id: number | string) {
    return this.http.delete(`${this.host}/partner-contracts/${contract_id}`);
  }

  createPartnerContractVariableCondition(
    contract_id: number | string,
    body: { start_date: string; end_date?: string | null; department_ids?: number[] }
  ) {
    return this.http.post<PartnerContractVariableCondition>(`${this.host}/partner-contract-variable-conditions`, {
      ...body,
      partner_contract_id: contract_id,
    });
  }

  updatePartnerContractVariableCondition(
    contract_id: number | string,
    condition_id: number | string,
    body: Partial<{ start_date: string; end_date: string | null; department_ids: number[] }>
  ) {
    return this.http.put<PartnerContractVariableCondition>(`${this.host}/partner-contract-variable-conditions/${condition_id}`, body);
  }

  deletePartnerContractVariableCondition(contract_id: number | string, condition_id: number | string) {
    return this.http.delete(`${this.host}/partner-contract-variable-conditions/${condition_id}`);
  }

  getCompanyUsers(id: number, query: any = {}) {
    return this.http.get<User[]>(`${this.host}/companies/${id}/users`, {
      params: query,
    });
  }

  /**
   * -------------------------------------------------- PROVIDERS --------------------------------------------------
   */
  getProviders(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<Provider[]>(`${this.host}/providers`, {
      params: http_params,
    });
  }

  getProvidersPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<Provider>>(`${this.host}/providers`, {
      params: http_params,
    });
  }

  getProvider(id: string) {
    return this.http.get<Provider>(`${this.host}/providers/${id}`);
  }

  createProvider(body: Provider) {
    return this.http.post<Provider>(`${this.host}/providers`, body);
  }

  updateProvider(id: string, body: any) {
    return this.http.put<Provider>(`${this.host}/providers/${id}`, body);
  }

  deleteProvider(id: number) {
    return this.http.delete<Provider>(`${this.host}/providers/${id}`);
  }

  /**
   * -------------------------------------------------- WORKING TIME --------------------------------------------------
   */
  getWorkingTimeSummary(user_id: string, from: Date, to: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToString(from));
    params = params.set('to', this.utils.dateToString(to));

    return this.http.get<WorkingTimeSummary>(`${this.host}/working-times/summary/${user_id}`, { params: params }).pipe(
      map((wts: WorkingTimeSummary) => {
        // Convert period strings to Date objects if needed
        if (wts.period && Array.isArray(wts.period)) {
          wts.period = wts.period.map(d => (typeof d === 'string' ? new Date(d) : d));
        }
        return wts;
      })
    );
  }

  createWorkingTime(body: WorkingTime) {
    return this.http.post<WorkingTime>(`${this.host}/working-times`, body);
  }

  updateWorkingTime(id: string, body: any) {
    return this.http.put<WorkingTime>(`${this.host}/working-times/${id}`, body);
  }

  deleteWorkingTime(id: number) {
    return this.http.delete<WorkingTime>(`${this.host}/working-times/${id}`);
  }

  getWorkingTimeChartData(period: string, params: any) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<any>(`${this.host}/working-times/charts/${period}`, {
      params: http_params,
    });
  }

  getWorkingTimeCSV(params: any) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get(`${this.host}/working-times/csv`, {
      params: http_params,
      observe: 'response',
      responseType: 'blob',
    });
  }

  getCompanyProductEpicsByCompanyProduct(company_product_id: string) {
    return this.http.get<CompanyProductEpic[]>(`${this.host}/company-products/${company_product_id}/company-product-epics`);
  }

  getWorkingTimeReportBusinessPartner(
    company_product_id: string,
    from: string,
    to: string,
    multiplier: number,
    use_time_invested: boolean = false,
    format: 'pdf' | 'csv' = 'pdf',
    company_product_epic_ids: (number | null)[] = []
  ) {
    let params: HttpParams = new HttpParams().set('from', from).set('to', to);
    if (multiplier) params = params.set('multiplier', multiplier.toString());
    if (use_time_invested) params = params.set('use_time_invested', 'true');
    if (format) params = params.set('format', format);
    if (company_product_epic_ids?.length) {
      company_product_epic_ids.forEach(id => {
        params = params.append('company_product_epic_ids[]', id === null ? 'null' : id.toString());
      });
    }
    return this.http.get(`${this.host}/company-products/${company_product_id}/working-times-report`, {
      params: params,
      observe: 'response',
      responseType: 'blob',
    });
  }

  getPartnerReportByValue(company_product_id: string, from: string, to: string, include_internal_meetings: boolean = false) {
    let params: HttpParams = new HttpParams().set('from', from).set('to', to);
    if (include_internal_meetings) {
      params = params.set('include_internal_meetings', 'true');
    }
    return this.http.get(`${this.host}/company-products/${company_product_id}/partner-report-by-value`, {
      params: params,
      observe: 'response',
      responseType: 'blob',
    });
  }

  /**
   * -------------------------------------------------- WORKING TIME CATEGORY --------------------------------------------------
   */
  getWorkingTimeCategories(params: any = {}) {
    return this.http.get<WorkingTimeCategory[]>(`${this.host}/working-time-categories`, { params: params });
  }

  getWorkingTimeCategory(id_or_slug: string) {
    return this.http.get<WorkingTimeCategory>(`${this.host}/working-time-categories/${id_or_slug}`);
  }

  /**
   * -------------------------------------------------- CLOCK REGISTERS --------------------------------------------------
   */
  getClockRegistersByUserId(user_id: string, params: any) {
    const query: HttpParams = this.setParams(params);
    return this.http.get<ClockRegister[]>(`${this.host}/users/${user_id}/clock-registers`, { params: query });
  }

  /**
   * -------------------------------------------------- VACATIONS (NEW SELF-SERVICE SYSTEM) ------------------------------------------------
   */
  createVacations(days: string[], year: number, userId?: number) {
    const body: { days: string[]; year: number; user_id?: number } = { days, year };
    if (userId != null) {
      body.user_id = userId;
    }
    return this.http.post<LongTask>(`${this.host}/vacations`, body);
  }

  deleteVacation(id: number) {
    return this.http.delete(`${this.host}/vacations/${id}`);
  }

  getMonthAvailability(month: string, selectedDays: string[] = [], year: number): Observable<MonthVacationAvailability> {
    let params = new HttpParams().set('month', month);
    params = params.set('year', year);

    if (selectedDays.length > 0) {
      selectedDays.forEach(day => {
        params = params.append('selected_days[]', day);
      });
    }

    return this.http.get<MonthVacationAvailability>(`${this.host}/me/vacations/month-availability`, {
      params,
    });
  }

  /**
   * -------------------------------------------------- VACATION LIMITS CONFIGURATION --------------------------------------------------
   */
  getVacationLimitsConfigurations(params: any = {}) {
    return this.http.get<VacationLimitsConfiguration[]>(`${this.host}/vacation-limits-configurations`, { params });
  }

  getVacationLimitsConfiguration(id: number) {
    return this.http.get<VacationLimitsConfiguration>(`${this.host}/vacation-limits-configurations/${id}`);
  }

  createVacationLimitsConfiguration(body: VacationLimitsConfiguration) {
    return this.http.post<VacationLimitsConfiguration>(`${this.host}/vacation-limits-configurations`, body);
  }

  updateVacationLimitsConfiguration(id: number, body: Partial<VacationLimitsConfiguration>) {
    return this.http.put<VacationLimitsConfiguration>(`${this.host}/vacation-limits-configurations/${id}`, body);
  }

  deleteVacationLimitsConfiguration(id: number) {
    return this.http.delete(`${this.host}/vacation-limits-configurations/${id}`);
  }

  /**
   * -------------------------------------------------- WORKING CONTRACT --------------------------------------------------
   */
  private onReceiveWorkingContract = (wc: WorkingContract, params: any) => {
    wc.start_date = new Date(wc.start_date);
    if (wc.end_date != null) wc.end_date = new Date(wc.end_date);

    if (
      params != null &&
      params.day != null &&
      params.with != null &&
      params.with.includes('current_working_contract_variable_condition')
    ) {
      const resolved = this.resolveCurrentWorkingContractVariableCondition(
        wc.current_working_contract_variable_condition,
        wc.working_contract_variable_conditions,
        params.day
      );
      if (resolved != null) {
        wc.current_working_contract_variable_condition = resolved;
      }
    }

    return wc;
  };

  private resolveCurrentWorkingContractVariableCondition(
    current_condition: WorkingContractVariableCondition | undefined,
    conditions: WorkingContractVariableCondition[] | undefined,
    day: string
  ): WorkingContractVariableCondition | undefined {
    if (current_condition != null) {
      return current_condition;
    }

    if (conditions == null || conditions.length === 0) {
      return undefined;
    }

    if (conditions.length === 1) {
      return conditions[0];
    }

    const reference_day = dayjs.tz(day, 'Europe/Madrid').startOf('day');
    const today = dayjs().tz('Europe/Madrid').startOf('day');
    const resolve_for = reference_day.isSame(today, 'week') ? today : reference_day;

    const active_condition = conditions.find(condition => {
      const start = dayjs(condition.start_date).tz('Europe/Madrid');
      const end = condition.end_date != null ? dayjs(condition.end_date).tz('Europe/Madrid') : null;

      return !resolve_for.isBefore(start, 'day') && (end == null || !resolve_for.isAfter(end));
    });

    return active_condition ?? conditions[0];
  }

  getActiveWorkingContract(user_id: number, params: any = null) {
    const query: HttpParams = this.setParams(params);
    return this.http
      .get<WorkingContract>(`${this.host}/users/${user_id}/working-contracts/active`, { params: query })
      .pipe(map(wc => this.onReceiveWorkingContract(wc, params)));
  }

  getActiveWorkingContractInWeek(user_id: number, params: any = null) {
    const query: HttpParams = this.setParams(params);
    return this.http
      .get<WorkingContract>(`${this.host}/users/${user_id}/working-contracts/active-in-week`, { params: query })
      .pipe(map(wc => this.onReceiveWorkingContract(wc, params)));
  }

  /** Horario de la semana (plantilla + excepción) por usuario; `start_week_date` = lunes YYYY-MM-DD (Europe/Madrid). */
  getActiveWorkingContractScheduleForUser(user_id: number, start_week_date?: string) {
    const query_params = start_week_date != null && start_week_date !== '' ? { start_week_date } : {};
    const query: HttpParams = this.setParams(query_params);
    return this.http.get<WorkingContractScheduleForWeekResponse>(`${this.host}/users/${user_id}/working-contracts/active/schedule`, {
      params: query,
    });
  }

  getUserExpectedHoursByDay(user_id: number, monday: string): Observable<number[]> {
    return this.http
      .get<{
        days: { total_hours: number }[];
      }>(`${this.host}/users/${user_id}/working-contracts/total-availability-expected`, { params: { monday } })
      .pipe(
        map(
          (availability: {
            days: {
              total_hours: number;
            }[];
          }) =>
            availability.days.map((d: { total_hours: number }): number => {
              return d.total_hours;
            })
        )
      );
  }

  getActiveWorkingContractNextSalarialUpgrade(user_id: number, params: any = {}) {
    return this.http.get<{ data: WorkingContractVariableCondition }>(
      `${this.host}/users/${user_id}/working-contracts/active/next-salarial-upgrade`,
      { params: params }
    );
  }

  /**
   * -------------------------------- WORKING CONTRACT VARIABLE CONDITION --------------------------------
   */
  updateWorkingContractVariableCondition(id: number, body: { start_date: string | null; end_date: string | null }) {
    return this.http.patch(`${this.host}/working-contract-variable-conditions/${id}`, body);
  }

  cloneWorkingContractVariableCondition(id: number, new_working_contract_variable_condition_start_date: string) {
    return this.http.post(`${this.host}/working-contract-variable-conditions/${id}/clone`, {
      new_working_contract_variable_condition_start_date,
    });
  }

  deleteWorkingContractVariableCondition(id: number) {
    return this.http.delete(`${this.host}/working-contract-variable-conditions/${id}`);
  }

  /**
   * -------------------------------- WORKING CONTRACT WEEKLY SCHEDULES --------------------------------
   */
  storeWorkingContractWeeklySchedule(
    working_contract_id: number,
    data: StoreWorkingContractWeeklySchedulePayload,
    start_week_date: string
  ) {
    return this.http.post<WorkingContractWeeklySchedule>(
      `${this.host}/working-contracts/${working_contract_id}/working-contract-weekly-schedules`,
      data,
      { params: { start_week_date } }
    );
  }

  updateOrCreateWorkingContractWeeklyScheduleException(
    working_contract_id: number,
    data: UpdateOrCreateWorkingContractWeeklyScheduleExceptionPayload,
    start_week_date: string
  ) {
    return this.http.post<WorkingContractWeeklyScheduleException>(
      `${this.host}/working-contracts/${working_contract_id}/working-contract-weekly-schedule-exceptions`,
      data,
      { params: { start_week_date } }
    );
  }

  getWorkingContractScheduleForWeek(working_contract_id: number, start_week_date: string) {
    return this.http.get<WorkingContractScheduleForWeekResponse>(
      `${this.host}/working-contracts/${working_contract_id}/schedule-for-week`,
      { params: { start_week_date } }
    );
  }

  /**
   * -------------------------------------------------- CLOCK REGISTER REVIEW REQUESTS --------------------------------------------------
   */
  getClockRegisterReviewRequestsPaged(params: any) {
    const query: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<ClockRegisterReviewRequest>>(`${this.host}/clock-register-review-requests`, { params: query });
  }

  createClockRegisterReviewRequest(c: ClockRegisterReviewRequest) {
    return this.http.post<ClockRegisterReviewRequest>(`${this.host}/clock-register-review-requests`, c);
  }

  updateClockRegisterReviewRequest(id: string, body: any) {
    return this.http.put<WorkingTime>(`${this.host}/clock-register-review-requests/${id}`, body);
  }

  getWorkingContractWeeklyScheduleExceptionRequests(
    params: WorkingContractWeeklyScheduleExceptionRequestIndexParams = {}
  ): Observable<ArrayResponse<WorkingContractWeeklyScheduleExceptionRequest>> {
    return this.http.get<ArrayResponse<WorkingContractWeeklyScheduleExceptionRequest>>(
      `${this.host}/working-contract-weekly-schedule-exception-requests`,
      { params: this.setParams(params) }
    );
  }

  createWorkingContractWeeklyScheduleExceptionRequest(
    body: StoreWorkingContractWeeklyScheduleExceptionRequestDTO
  ): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(`${this.host}/working-contract-weekly-schedule-exception-requests`, body, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true'),
    });
  }

  getWorkingContractWeeklyScheduleExceptionRequest(
    id: number,
    params: WorkingContractWeeklyScheduleExceptionRequestShowParams = {}
  ): Observable<WorkingContractWeeklyScheduleExceptionRequest> {
    return this.http.get<WorkingContractWeeklyScheduleExceptionRequest>(
      `${this.host}/working-contract-weekly-schedule-exception-requests/${id}`,
      { params: this.setParams(params) }
    );
  }

  updateWorkingContractWeeklyScheduleExceptionRequest(
    id: number,
    body: UpdateWorkingContractWeeklyScheduleExceptionRequestPayload
  ): Observable<WorkingContractWeeklyScheduleExceptionRequest> {
    return this.http.put<WorkingContractWeeklyScheduleExceptionRequest>(
      `${this.host}/working-contract-weekly-schedule-exception-requests/${id}`,
      body
    );
  }

  /**
   * -------------------------------------------------- EMPLOYEE CALENDAR REGISTERS --------------------------------------------------
   * */

  getEmployeeCalendarRegistersForUserSerialized(id: string, from: Date | undefined, to: Date | undefined, query: any = {}) {
    let params: HttpParams = this.setParams(query);

    if (from) params = params.set('from', this.utils.dateToString(from));
    if (to) params = params.set('to', this.utils.dateToString(to));

    return this.http
      .get<
        EmployeeCalendarRegisterWithRelationsSerialized[]
      >(`${this.host}/users/${id}/employee-calendar-registers/serialized`, { params: params })
      .pipe(
        map(ecr_array => {
          return ecr_array.map(ecr => {
            ecr.from_date = new Date(ecr.from_date);
            ecr.to_date = new Date(ecr.to_date);
            return ecr;
          });
        })
      );
  }

  getEmployeeRemoteWork(id: string, from: Date, to: Date) {
    let params: HttpParams = new HttpParams();

    params = params.set('from', this.utils.dateToString(from));
    params = params.set('to', this.utils.dateToString(to));

    return this.http.get<Date[]>(`${this.host}/users/${id}/remote-work`, {
      params: params,
    });
  }

  createEmployeeRemoteWorkExceptionRequest(
    id: string,
    from: Date,
    to: Date,
    body: UpsertRemoteWorkExceptionRequestBody
  ): Observable<RemoteWorkExceptionRequest> {
    let params: HttpParams = new HttpParams();

    params = params.set('from', this.utils.dateToString(from));
    params = params.set('to', this.utils.dateToString(to));

    return this.http.post<RemoteWorkExceptionRequest>(`${this.host}/users/${id}/remote-work`, body, {
      params,
    });
  }

  /**
   * -------------------------------------------------- REMOTE WORK EXCEPTION REQUESTS --------------------------------------------------
   */

  getRemoteWorkExceptionRequests(params: any = null) {
    return this.http.get<ArrayResponse<RemoteWorkExceptionRequest>>(`${this.host}/remote-work-weekday-exception-requests`, {
      params: params,
    });
  }

  updateRemoteWorkExceptionRequest(id: number, body: UpdateRemoteWorkExceptionRequestBody): Observable<RemoteWorkExceptionRequest> {
    return this.http.put<RemoteWorkExceptionRequest>(`${this.host}/remote-work-weekday-exception-requests/${id}`, body);
  }

  getEmployeeRequestResponsibleForAnswers(params: HttpQueryParams = {}): Observable<ArrayResponse<EmployeeRequestResponsibleForAnswer>> {
    return this.http.get<ArrayResponse<EmployeeRequestResponsibleForAnswer>>(`${this.host}/employee-request-responsible-for-answers`, {
      params,
    });
  }

  /**
   * -------------------------------------------------- EMPLOYEE CALENDAR REGISTERS --------------------------------------------------
   * */

  getEmployeeCalendarRegisterCanIEdit(id: number) {
    return this.http.get<{ can_edit: boolean }>(`${this.host}/employee-calendar-registers/${id}/can-i-edit`);
  }

  saveBulkEmployeeCalendarRegisters(body: any) {
    return this.http.post<EmployeeCalendarRegister[]>(`${this.host}/employee-calendar-registers/bulk`, body);
  }

  /**
   * -------------------------------------------------- WEEKLY WORKING TIME BUDGET --------------------------------------------------
   * */
  saveBulkWeeklyWorkingTimeBudgets(data: any[]) {
    return this.http.post<WeeklyWorkingTimeBudget[]>(`${this.host}/weekly-working-time-budgets/bulk`, data);
  }

  getWeeklyWorkingTimeBudget(id: string, params: any = null) {
    const query: HttpParams = this.setParams(params);
    return this.http.get<WeeklyWorkingTimeBudget>(`${this.host}/weekly-working-time-budgets/${id}`, { params: query });
  }

  getWeeklyWorkingTimeBudgetDistributionDistributable(id: string, params: any = null) {
    const query: HttpParams = this.setParams(params);
    return this.http.get<WeeklyWorkingTimeBudgetDistributionDistributable[]>(
      `${this.host}/weekly-working-time-budgets/${id}/distributables`,
      { params: query }
    );
  }

  updateWeeklyWorkingTimeBudgetAndChargeDefaults(id: string, hours: number = null as any) {
    const body: any = {};
    if (hours != null) body.hours = hours;

    return this.http.put<WeeklyWorkingTimeBudget>(`${this.host}/weekly-working-time-budgets/${id}/update-and-charge-defaults`, body);
  }

  getWeeklyWorkingTimeBudgetInfo(id: string, idDistributable: string) {
    return this.http.get<WeeklyWorkingTimeBudgetInfo>(
      `${this.host}/weekly-working-time-budgets/${id}/weekly-working-time-budget-distributables/${idDistributable}`
    );
  }

  updateWeeklyWorkingTimeBudgetDistributionDistributableBulk(body: any) {
    return this.http.put<WeeklyWorkingTimeBudgetDistributionDistributable[]>(
      `${this.host}/weekly-working-time-budget-distributables/bulk`,
      body
    );
  }

  /**
   * -------------------------------------------------- WEEKLY WORKING TIME BUDGET EMPLOYEE -----------------------------------------------
   * */
  saveBulkWeeklyWorkingTimeBudgetEmployee(payload: { notification_type?: 'final' | 'change' | 'broadcast' | 'dont_notify'; data: any[] }) {
    return this.http.post<WeeklyWorkingTimeBudgetEmployee[]>(`${this.host}/weekly-working-time-budget-employees/bulk`, payload);
  }

  getWeeklyWorkingTimeBudgetEmployeeEmployees(from: Date, to: Date) {
    let params: HttpParams = new HttpParams();
    params = params.set('from', this.utils.dateToStringYYYYMMDD(from));
    params = params.set('to', this.utils.dateToStringYYYYMMDD(to));

    return this.http.get<User[]>(`${this.host}/weekly-working-time-budget-employees/employees`, { params: params });
  }

  getWeeklyWorkingTimeBudgetEmployees(params: any) {
    const query: HttpParams = this.setParams(params);

    return this.http.get<WeeklyWorkingTimeBudgetEmployee[]>(`${this.host}/weekly-working-time-budget-employees`, { params: query });
  }

  getWeeklyWorkingTimeBudgetEmployeesSerialized(params: any) {
    const query: HttpParams = this.setParams(params);

    return this.http.get<WeeklyWorkingTimeBudgetEmployeeSerialized[]>(`${this.host}/weekly-working-time-budget-employees/serialized`, {
      params: query,
    });
  }

  // ------------------------------------------------------ PHASE BOARDS --------------------------------------------------

  getPhaseBoards(phaseId: any, params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http
      .get<CompanyProductPhaseBoard[]>(`${this.host}/company-product-phases/${phaseId}/phase-boards`, { params: http_params })
      .pipe(
        map(val => {
          val.forEach(board => {
            if (board.start_date != null) board.start_date = new Date(board.start_date);
            if (board.end_date != null) board.end_date = new Date(board.end_date);
          });
          return val;
        })
      );
  }

  updateCompanyProductPhaseBoard(id: string, body: any) {
    return this.http.put<CompanyProductPhaseBoard>(`${this.host}/company-product-phase-boards/${id}`, body, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  completeCompanyProductPhaseBoard(id: string, body: any) {
    return this.http.post<CompanyProductPhaseBoard>(`${this.host}/company-product-phase-boards/${id}/complete`, body, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  createCompanyProductPhaseBoard(body: any) {
    return this.http.post<CompanyProductPhaseBoard>(`${this.host}/company-product-phase-boards`, body, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  deleteCompanyProductPhaseBoard(id: string) {
    return this.http.delete<CompanyProductPhaseBoard>(`${this.host}/company-product-phase-boards/${id}`, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  archiveBoard(id: string) {
    return this.http.put<CompanyProductPhaseBoard>(`${this.host}/company-product-phase-boards/${id}/archive`, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  // ------------------------------------------------------ COMPANY_PRODUCT TASK TIME BUDGETS --------------------------------------------------

  createProductTaskTimeBudget(body: any) {
    return this.http.post<ProductTaskTimeBudget>(`${this.host}/product-task-time-budgets`, body, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  deleteProductTaskTimeBudget(id: number) {
    return this.http.delete<ProductTaskTimeBudget>(`${this.host}/product-task-time-budgets/${id}`, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  markProductTaskTimeBudgetAsCompleted(id: number) {
    return this.http.post<MarkProductTaskTimeBudgetResponse>(
      `${this.host}/product-task-time-budgets/${id}/mark-as-completed`,
      {},
      {
        headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
      }
    );
  }

  markProductTaskTimeBudgetAsUncompleted(id: number) {
    return this.http.post<MarkProductTaskTimeBudgetResponse>(
      `${this.host}/product-task-time-budgets/${id}/mark-as-uncompleted`,
      {},
      {
        headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
      }
    );
  }

  // ------------------------------------------------------ COMPANY_PRODUCT PHASE BOARDS --------------------------------------------------
  getCompanyProductPhaseBoard(board_id: number, params: any = {}) {
    return this.http.get<CompanyProductPhaseBoard>(`${this.host}/company-product-phase-boards/${board_id}`, {
      params: params,
    });
  }

  getCompanyProductPhaseBoardStructure(board_id: number, params: any = {}) {
    return this.http.get<{
      company_product_phase_board: CompanyProductPhaseBoard;
      columns: {
        column: CompanyProductPhaseBoardCol;
        product_task_boards: ProductTaskBoard[];
      }[];
    }>(`${this.host}/company-product-phase-boards/${board_id}/board-structure`, {
      params: params,
    });
  }

  addTaskToBoardFromBacklog(board_id: number, product_task_id: number): Observable<ProductTaskBoard> {
    return this.http.post<ProductTaskBoard>(
      `${this.host}/company-product-phase-boards/${board_id}/add-task`,
      { product_task_id },
      { headers: new HttpHeaders().set('avoid-snackbar-notification', 'true') }
    );
  }

  changeBoardColumnsOrder(board_id: number, columns: any) {
    return this.http.put<CompanyProductPhaseBoardCol>(
      `${this.host}/company-product-phase-boards/${board_id}/change-columns-order`,
      columns
    );
  }

  changeBoardColumnTasksOrder(board_id: number, product_task_board_ids: number[]) {
    return this.http.put<ProductTaskBoard>(
      `${this.host}/company-product-phase-boards/${board_id}/change-tasks-order`,
      product_task_board_ids
    );
  }

  moveTaskFromColumnToColumn(
    board_id: number,
    product_task_board_id: number,
    colDestination: CompanyProductPhaseBoardCol,
    newIndex: number,
    decline_reasons: number[] | null = null,
    query: any = {}
  ) {
    return this.http.put<ProductTaskBoard>(
      `${this.host}/company-product-phase-boards/${board_id}/change-task-column`,
      {
        column_id: colDestination.id,
        product_task_board_id: product_task_board_id,
        index: newIndex,
        decline_reasons: decline_reasons,
      },
      {
        params: query,
      }
    );
  }

  createBoardColumn(column: any) {
    return this.http.post<CompanyProductPhaseBoardCol>(`${this.host}/company-product-phase-board-cols`, column, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  // ------------------------------------------------------ COMPANY_PRODUCT TASKS --------------------------------------------------
  getProductTasks(params: any = {}) {
    return this.http.get<ArrayResponse<ProductTask>>(`${this.host}/product-tasks`, { params: params });
  }

  getTaskByCode(code: string, params: any = {}) {
    return this.http.get<ProductTask>(`${this.host}/product-tasks/code/${code}`, {
      params: params,
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  createTask(task: any): Observable<ProductTask> {
    return this.http.post<ProductTask>(`${this.host}/product-tasks`, task);
  }

  saveBulkProductTasks(tasks: any[]) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/bulk`, tasks);
  }

  saveBulkProductTasksXlsx(data: { company_product_phase_id: number; board_id: string | number }, xlsx: File) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(data));
    formData.append('file', xlsx);
    return this.http.post<ProductTask[]>(`${this.host}/product-tasks/bulk/xlsx`, formData);
  }

  updateTask(task: any) {
    return this.http.put<ProductTask>(`${this.host}/product-tasks/${task.id}`, task);
  }

  updateTaskAssignMe(task_id: string) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/${task_id}/assign-me`, {});
  }

  removeTaskAssignedUser(task_id: string) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/${task_id}/remove-assigned-user`, {});
  }

  attachTaskFile(task_id: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<Attachment>(`${this.host}/product-tasks/${task_id}/attachments`, formData);
  }

  attachTaskFiles(task_id: number, files: File[]) {
    const formData = new FormData();
    files.forEach(f => formData.append('files[]', f));
    return this.http.post<Attachment[]>(`${this.host}/product-tasks/${task_id}/attachments/bulk`, formData);
  }

  deleteAttachedTaskFile(task_id: number, file_id: number) {
    return this.http.delete(`${this.host}/product-tasks/${task_id}/attachments/${file_id}`);
  }

  downloadAttachedTaskFile(task_id: number, file_id: number) {
    return this.http.get(`${this.host}/product-tasks/${task_id}/attachments/${file_id}`, { observe: 'response', responseType: 'blob' });
  }

  attachMeetingRecordFile(meeting_record_id: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<Attachment>(`${this.host}/meeting-records/${meeting_record_id}/attachments`, formData);
  }

  attachMeetingRecordFiles(meeting_record_id: number, files: File[]) {
    const formData = new FormData();
    files.forEach(f => formData.append('files[]', f));
    return this.http.post<Attachment[]>(`${this.host}/meeting-records/${meeting_record_id}/attachments/bulk`, formData);
  }

  deleteMeetingRecordAttachment(meeting_record_id: number, file_id: number) {
    return this.http.delete(`${this.host}/meeting-records/${meeting_record_id}/attachments/${file_id}`);
  }

  downloadMeetingRecordAttachment(meeting_record_id: number, file_id: number) {
    return this.http.get(`${this.host}/meeting-records/${meeting_record_id}/attachments/${file_id}`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  getTask(task_id: number, params: any = {}) {
    return this.http.get<ProductTask>(`${this.host}/product-tasks/${task_id}`, {
      params: params,
    });
  }

  getProductTaskComments(product_task_id: number) {
    return this.http.get<ProductTaskComment[]>(`${this.host}/product-tasks/${product_task_id}/comments`, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  getProductTaskWorkingTimes(product_task_id: number) {
    return this.http.get<WorkingTime[]>(`${this.host}/product-tasks/${product_task_id}/working-times`, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  getProductTaskCompanyProductDeploys(product_task_id: number) {
    return this.http.get<CompanyProductDeploy[]>(`${this.host}/product-tasks/${product_task_id}/company-product-deploys`, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  getProductTaskHistoryLogs(product_task_id: number) {
    return this.http.get<ProductTaskHistoryLog[]>(`${this.host}/product-tasks/${product_task_id}/product-task-history-logs`, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  getProductTaskCompanyProductPhaseBoards(product_task_id: number) {
    return this.http.get<{ company_product_phase_id: number; company_product_phase_boards: CompanyProductPhaseBoard[] }>(
      `${this.host}/product-tasks/${product_task_id}/company-product-phase-boards`,
      {
        headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
      }
    );
  }

  getTaskMembers(task_id: number) {
    return this.http.get<ProductTaskMember>(`${this.host}/product-tasks/${task_id}/members`);
  }

  deleteTask(task_id: number) {
    return this.http.delete<ProductTask>(`${this.host}/product-tasks/${task_id}`);
  }

  deleteBoardColumn(column_id: number) {
    return this.http.delete<CompanyProductPhaseBoard>(`${this.host}/company-product-phase-board-cols/${column_id}`);
  }

  updateBoardColumn(column: any) {
    return this.http.put<CompanyProductPhaseBoard>(`${this.host}/company-product-phase-board-cols/${column.id}`, column);
  }

  archiveTasks(data: ArchiveProductTasksRequest): Observable<boolean> {
    return this.http.put<boolean>(`${this.host}/product-tasks/archive`, data);
  }

  listenTask($task_id: number, $user_id: number) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/${$task_id}/listen/${$user_id}`, {});
  }

  unlistenTask($task_id: number, $user_id: number) {
    return this.http.delete<ProductTask>(`${this.host}/product-tasks/${$task_id}/listen/${$user_id}`, {});
  }

  attachProductTaskRequester(task_id: number, user_id: number) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/${task_id}/requesters/${user_id}`, {});
  }

  detachProductTaskRequester(task_id: number, user_id: number) {
    return this.http.delete<ProductTask>(`${this.host}/product-tasks/${task_id}/requesters/${user_id}`);
  }

  requireClientApproveTask(task_id: number) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/${task_id}/require-client-approve`, {});
  }

  approveTask(task_id: number) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/${task_id}/client-approve`, {});
  }

  declineTask(task_id: number) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/${task_id}/client-decline`, {});
  }

  reaskApprovalTask(task_id: number) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/${task_id}/client-reask-for-approval`, {});
  }

  cancelApprovalTaskRequest(task_id: number) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/${task_id}/cancel-approval-request`, {});
  }

  updateProductTaskTimeBudgets(task_id: number, product_task_time_budgets: ProductTaskTimeBudget[], avoid_snackbar: boolean = false) {
    const headers: Record<string, string> = {};
    if (avoid_snackbar) {
      headers['avoid-snackbar-notification'] = 'true';
      headers['avoid-loading'] = 'true';
    }

    return this.http.put<ProductTask>(`${this.host}/product-tasks/${task_id}/time-budgets`, product_task_time_budgets, {
      headers: new HttpHeaders(headers),
    });
  }

  updateProductTaskTimeAndWorkDistribution(product_task_id: number, data: ProductTaskDistribution) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/${product_task_id}/time-work-distribution`, data);
  }

  setProductTaskTimeEstimation(id: number, time_in_seconds: number) {
    return this.http.put<ProductTask>(`${this.host}/product-tasks/${id}/time-estimation`, { time_in_seconds: time_in_seconds });
  }

  moveTaskToPhase(product_task_id: number, company_product_phase_id: number) {
    return this.http.post<ProductTask>(`${this.host}/product-tasks/${product_task_id}/move-to-company-product-phase`, {
      company_product_phase_id: company_product_phase_id,
    });
  }

  // getProductTaskUpdatedHistoryLogs(id: number) {
  //   return this.http.get<ProductTaskHistoryLog[]>(
  //     `${this.host}/product-tasks/${id}/history-logs`
  //   )
  // }

  getProductTaskDeclineReasons(working_time_category_id: number | null) {
    return this.http.get<ArrayResponse<ProductTaskDeclineReason>>(
      `${this.host}/product-task-decline-reasons/by-category/${working_time_category_id}`
    );
  }

  // ------------------------------------------------------ COMPANY_PRODUCT TASK BOARD --------------------------------------------------
  getProductTaskBoard(id: number, params: any = {}) {
    return this.http.get<ProductTaskBoard>(`${this.host}/product-task-boards/${id}`, { params: params });
  }

  createProductTaskBoard(data: ProductTaskBoard, avoid_snackbar: boolean = false) {
    const headers: any = {};
    if (avoid_snackbar) headers['avoid-snackbar-notification'] = 'true';
    return this.http.post<ProductTaskBoard>(`${this.host}/product-task-boards`, data, { headers: headers });
  }

  updateProductTaskBoard(id: number, body: any = {}, decline_reasons: number[] | null = null) {
    const payload = {
      ...body,
      ...(decline_reasons ? { decline_reasons } : {}),
    };
    return this.http.put<ProductTaskBoard>(`${this.host}/product-task-boards/${id}`, payload);
  }

  deleteProductTaskBoard(id: number) {
    return this.http.delete<ProductTaskBoard>(`${this.host}/product-task-boards/${id}`);
  }

  setProductTaskBoardTimeEstimation(id: number, time_in_seconds: number) {
    return this.http.put<ProductTaskBoard>(`${this.host}/product-task-boards/${id}/time-estimation`, { time_in_seconds: time_in_seconds });
  }

  reRequestProductTaskBoardReview(id: number) {
    return this.http.post<ProductTaskBoard>(`${this.host}/product-task-boards/${id}/request-review`, {});
  }

  // ------------------------------------------------------ COMPANY_PRODUCT PHASE BOARD COL ROLE --------------------------------------------------

  getCompanyProductPhaseBoardColRoles() {
    return this.http.get<CompanyProductPhaseBoardColRole[]>(`${this.host}/company-product-phase-board-col-roles`);
  }

  // ------------------------------------------------------ ENVIRONMENTS --------------------------------------------------

  getEnvironments() {
    return this.http.get<Environment[]>(`${this.host}/environments`);
  }

  // ------------------------------------------------------ COMPANY_PRODUCT TASK COMMENTS --------------------------------------------------

  createComment(comment: any) {
    return this.http.post<ProductTaskComment>(`${this.host}/product-task-comments`, comment, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  updateComment(comment: any) {
    return this.http.put<ProductTaskComment>(`${this.host}/product-task-comments/${comment.id}`, comment, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  deleteComment(comment_id: number) {
    return this.http.delete<ProductTaskComment>(`${this.host}/product-task-comments/${comment_id}`, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  // ------------------------------------------------------ COMPANY_PRODUCT TASK TAG --------------------------------------------------

  getTaskTagCategories(params: any = {}) {
    const http_params = this.setParams(params);

    return this.http.get<ProductTaskTagCategory[]>(`${this.host}/product-task-tag-categories`, { params: http_params });
  }

  createTaskTagCategory(category: any) {
    return this.http.post<ProductTaskTagCategory>(`${this.host}/product-task-tag-categories`, category, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  createTaskTag(tag: any) {
    return this.http.post<ProductTaskTag>(`${this.host}/product-task-tags`, tag, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  deleteTaskTag(tag_id: number) {
    return this.http.delete<ProductTaskTag>(`${this.host}/product-task-tags/${tag_id}`, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  updateProductTask(task: ProductTask) {
    return this.http.put<ProductTask>(`${this.host}/product-tasks/${task.id}`, task, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  /**
   * -------------------------------------------------- POTENTIAL CLIENTS --------------------------------------------------
   */
  getPotentialClientsPaged(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<PotentialClient>>(`${this.host}/potential-clients`, { params: http_params });
  }

  getPotentialClientStatusCounts(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<{
      statuses: { slug: string; name: string; count: number }[];
      total: number;
    }>(`${this.host}/potential-clients/status-counts`, { params: http_params });
  }

  getPotentialClientsKpis(from: Date, to: Date, params: { commercial_ids?: number[]; origin_ids?: number[] } = {}) {
    let http_params = new HttpParams().set('from', this.utils.dateToStringYYYYMMDD(from)).set('to', this.utils.dateToStringYYYYMMDD(to));

    if (params.commercial_ids?.length) {
      http_params = http_params.set('commercial_ids', params.commercial_ids.join(','));
    }
    if (params.origin_ids?.length) {
      http_params = http_params.set('origin_ids', params.origin_ids.join(','));
    }

    return this.http.get<{
      summary: CommercialDashboardMetrics;
      days: CommercialDashboardMetrics[];
      commercials: { id: number; name: string; surnames: string }[];
    }>(`${this.host}/potential-clients/kpis`, {
      params: http_params,
    });
  }

  getPotentialClient(id: string, params: any = {}) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<PotentialClient>(`${this.host}/potential-clients/${id}`, { params: http_params });
  }

  createPotentialClient(data: any) {
    return this.http.post<PotentialClient>(`${this.host}/potential-clients`, data);
  }

  updatePotentialClient(id: string, data: any) {
    return this.http.put<PotentialClient>(`${this.host}/potential-clients/${id}`, data);
  }

  createPotentialClientAction(id: string | number, data: { type: string; notes?: string }) {
    return this.http.post<PotentialClientAction>(`${this.host}/potential-clients/${id}/actions`, data);
  }

  ingestRingoverCallRecording(
    potentialClientId: string | number,
    data: {
      call_id: string;
      called_at?: string;
    }
  ) {
    return this.http.post<{ meeting_record: { id: number; title: string }; already_queued: boolean }>(
      `${this.host}/potential-clients/${potentialClientId}/ringover-call-recordings`,
      data
    );
  }

  importPotentialClients(origin_id: number, file: File) {
    const form_data = new FormData();
    form_data.append('origin_id', String(origin_id));
    form_data.append('file', file);

    return this.http.post<{
      imported: number;
      skipped_duplicates: number;
      skipped_invalid: number;
      total_rows: number;
    }>(`${this.host}/potential-clients/import`, form_data);
  }

  syncMetaLeads(hours: number) {
    return this.http.post<{
      hours: number;
      since: string;
      seen: number;
      created: number;
      skipped: number;
      failed: number;
      failures: { leadgen_id: string; reason: string }[];
      last_synced_at?: string | null;
    }>(`${this.host}/potential-clients/sync-meta-leads`, { hours });
  }

  getMetaLeadsLastSync() {
    return this.http.get<{ last_synced_at: string | null }>(`${this.host}/potential-clients/meta-leads-last-sync`);
  }

  /**
   * -------------------------------------------------- POTENTIAL CLIENT ORIGIN --------------------------------------------------
   */
  getPotentialClientOrigins(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<PotentialClientOrigin>>(`${this.host}/potential-client-origins`, {
      params: http_params,
    });
  }

  createPotentialClientOrigin(data: { name: string }) {
    return this.http.post<PotentialClientOrigin>(`${this.host}/potential-client-origins`, data);
  }

  /**
   * -------------------------------------------------- LEAD ASSIGNMENT WEIGHTS (META) --------------------------------------------------
   */
  getPotentialClientLeadAssignmentWeights() {
    return this.http.get<ArrayResponse<LeadAssignmentWeightRow>>(`${this.host}/potential-client-lead-assignment-weights/board`);
  }

  getPotentialClientLeadAssignmentWeightsHistory() {
    return this.http.get<LeadAssignmentWeightHistoryPeriod[]>(`${this.host}/potential-client-lead-assignment-weights/history`);
  }

  syncPotentialClientLeadAssignmentWeights(data: { weights: { user_id: number; percentage: number }[] }) {
    return this.http.put<LeadAssignmentWeightRow[]>(`${this.host}/potential-client-lead-assignment-weights`, data);
  }

  /**
   * -------------------------------------------------- POTENTIAL CLIENT STATUS --------------------------------------------------
   */
  getPotentialClientStatus() {
    return this.http.get<PotentialClientStatus[]>(`${this.host}/potential-client-statuses`);
  }

  /**
   * -------------------------------------------------- POTENTIAL CLIENT COMMENT --------------------------------------------------
   */
  createPotentialClientComment(data: any) {
    return this.http.post<PotentialClientComment>(`${this.host}/potential-client-comments`, data);
  }

  /**
   * -------------------------------------------------- MEETING RECORD --------------------------------------------------
   */
  getMeetingRecords(params: Record<string, unknown> = {}) {
    return this.http.get<ArrayResponse<MeetingRecord> | MeetingRecord[]>(`${this.host}/meeting-records`, {
      params: this.setParams(params),
    });
  }

  getMeetingRecord(id: string, params: any = {}) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<MeetingRecord>(`${this.host}/meeting-records/${id}`, { params: http_params });
  }

  createMeetingRecord(data: any, options: { silent?: boolean } = {}) {
    return this.http.post<MeetingRecord>(`${this.host}/meeting-records`, data, {
      headers: this.buildSilentRequestHeaders(options.silent),
    });
  }

  updateMeetingRecord(id: string, data: any, options: { silent?: boolean } = {}) {
    return this.http.put<MeetingRecord>(`${this.host}/meeting-records/${id}`, data, {
      headers: this.buildSilentRequestHeaders(options.silent),
    });
  }

  getMeetingRecordPersonalNotes(meeting_record_id: number) {
    return this.http.get<{ personal_notes: string | null }>(`${this.host}/meeting-records/${meeting_record_id}/personal-notes`);
  }

  updateMeetingRecordPersonalNotes(meeting_record_id: number, personal_notes: string | null) {
    return this.http.patch<{ id: number; personal_notes: string | null }>(
      `${this.host}/meeting-records/${meeting_record_id}/personal-notes`,
      { personal_notes }
    );
  }

  deleteMeetingRecord(id: string) {
    return this.http.delete<MeetingRecord>(`${this.host}/meeting-records/${id}`);
  }

  downloadMeetingRecordPdf(id: string, sections: string[]) {
    return this.http.get(`${this.host}/meeting-records/${id}/pdf`, {
      params: { sections: sections.join(',') },
      observe: 'response',
      responseType: 'blob',
    });
  }

  generateMeetingRecordSummary(meeting_record_id: number, data: { media_recording_id: number; overwrite_existing_summary?: boolean }) {
    return this.http.post<{ message: string }>(`${this.host}/meeting-records/${meeting_record_id}/generate-summary`, data);
  }

  getMeetingRecordMediaRecordings(meeting_record_id: number, params: any = {}) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<MediaRecording[]>(`${this.host}/meeting-records/${meeting_record_id}/media-recordings`, {
      params: http_params,
    });
  }

  /**
   * -------------------------------------------------- MEDIA RECORDING --------------------------------------------------
   */
  getMediaRecordings(params: any = {}) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<MediaRecording>>(`${this.host}/media-recordings`, { params: http_params });
  }

  getMediaRecording(id: number, params: any = {}) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<MediaRecording>(`${this.host}/media-recordings/${id}`, { params: http_params });
  }

  createMediaRecording(data: CreateMediaRecordingBody) {
    return this.http.post<MediaRecording>(`${this.host}/media-recordings`, data);
  }

  updateMediaRecording(id: number, data: Partial<CreateMediaRecordingBody>) {
    return this.http.patch<MediaRecording>(`${this.host}/media-recordings/${id}`, data);
  }

  deleteMediaRecording(id: number) {
    return this.http.delete<void>(`${this.host}/media-recordings/${id}`, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true'),
    });
  }

  pauseMediaRecording(id: number) {
    return this.http.patch<MediaRecording>(`${this.host}/media-recordings/${id}/pause`, {});
  }

  resumeMediaRecording(id: number) {
    return this.http.patch<MediaRecording>(`${this.host}/media-recordings/${id}/resume`, {});
  }

  stopMediaRecording(id: number, data: { duration_seconds?: number; expected_chunk_count?: number }) {
    return this.http.patch<MediaRecording>(`${this.host}/media-recordings/${id}/stop`, data);
  }

  uploadMediaRecordingChunk(
    id: number,
    chunk_index: number,
    file: Blob,
    duration_ms?: number,
    segment_metadata?: { segment_index: number; part_index: number }
  ) {
    const form_data = new FormData();
    form_data.append('chunk_index', String(chunk_index));
    form_data.append('file', file, `recording-${id}-chunk-${chunk_index}.webm`);

    if (segment_metadata !== undefined) {
      form_data.append('segment_index', String(segment_metadata.segment_index));
      form_data.append('part_index', String(segment_metadata.part_index));
    }

    if (duration_ms !== undefined) {
      form_data.append('duration_ms', String(duration_ms));
    }

    return this.http.post<{ chunk: unknown; media_recording: MediaRecording }>(`${this.host}/media-recordings/${id}/chunks`, form_data, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true').set('avoid-loading', 'true'),
    });
  }

  retryMediaRecordingUpload(id: number) {
    return this.http.post<MediaRecording>(`${this.host}/media-recordings/${id}/retry-upload`, {});
  }

  finalizeMediaRecordingUpload(id: number) {
    return this.http.post<MediaRecording>(`${this.host}/media-recordings/${id}/finalize`, {});
  }

  getCompanyProductActiveCompanyProductWorkers(company_product_id: number) {
    return this.http.get<{ data: { id: number; full_name: string }[] }>(
      `${this.host}/company-products/${company_product_id}/users/active-workers`
    );
  }

  downloadMediaRecordingAudio(id: number) {
    return this.http.get(`${this.host}/media-recordings/${id}/download-audio`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  streamMediaRecording(id: number) {
    return this.http.get(`${this.host}/media-recordings/${id}/stream`, {
      responseType: 'blob',
    });
  }

  streamMediaRecordingAudio(id: number) {
    return this.http.get(`${this.host}/media-recordings/${id}/stream-audio`, {
      responseType: 'blob',
    });
  }

  updateMediaRecordingDiarization(id: number, interventions: MediaRecordingDiarizationIntervention[]) {
    return this.http.patch<MediaRecording>(`${this.host}/media-recordings/${id}/diarization`, {
      interventions,
    });
  }

  retryMediaRecordingTranscription(id: number) {
    return this.http.post<MediaRecording>(`${this.host}/media-recordings/${id}/retry-transcription`, {});
  }

  importMediaRecordingAudio(form_data: FormData) {
    return this.http.post<MediaRecording>(`${this.host}/media-recordings/import-audio`, form_data);
  }

  importMediaRecordingFromYoutube(data: {
    concept: string;
    client_local_id: string;
    youtube_url: string;
    recordable_type?: string;
    recordable_id?: number;
  }) {
    return this.http.post<MediaRecording>(`${this.host}/media-recordings/import-youtube`, data);
  }

  /**
   * -------------------------------------------------- POTENTIAL CLIENT STATUS CHANGE RECORDS ---------------------------------------------
   */
  getPotentialClientStatusChangeRecords(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<PotentialClientStatusChangeRecord>>(`${this.host}/potential-client-status-change-records`, {
      params: http_params,
    });
  }

  /**
   * -------------------------------------------------- BISUAL SETTINGS --------------------------------------------------
   */
  getBisualSettings(params: Record<string, string | string[]> = {}) {
    return this.http.get<BisualSetting[]>(`${this.host}/bisual-settings`, { params: params }).pipe(
      map(response => {
        const result: BisualSetting[] = [];
        // mapejem les dades al format esperat
        Object.values(response).forEach(setting => {
          Object.values(setting).forEach(values => {
            result.push(values);
          });
        });

        return result;
      })
    );
  }

  getBisualSettingsByKeys(keys: string[]) {
    return this.getBisualSettings({ keys: keys.join(',') });
  }

  getBisualSetting(key: string) {
    return this.http.get<BisualSetting>(`${this.host}/bisual-settings/${key}`);
  }

  updateBulkBisualSettings(data: any) {
    return this.http.put<BisualSetting[]>(`${this.host}/bisual-settings/bulk`, data);
  }

  /**
   * -------------------------------------------------- GENERAL SEARCH --------------------------------------------------
   */
  generalSearch(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<any[]>(`${this.host}/general-search`, {
      params: http_params,
    });
  }

  /**
   * -------------------------------------------------- WIKI NODE  --------------------------------------------------
   */
  getWikiTree(initial_node_id: number = null as any) {
    let http_params: HttpParams = new HttpParams();

    if (initial_node_id != null) {
      http_params = this.setParams({ initial_node_id: initial_node_id });
    }

    return this.http.get<WikiTree[]>(`${this.host}/wiki-nodes/tree`, {
      params: http_params,
    });
  }

  getWikiNode(id: number, params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<WikiNode>(`${this.host}/wiki-nodes/${id}`, {
      params: http_params,
    });
  }

  getWikiNodeBySlug(slug: string) {
    return this.http.get<WikiNode>(`${this.host}/wiki-nodes/slug/${slug}`);
  }

  createWikiNode(body: WikiNode | any) {
    return this.http.post<WikiNode>(`${this.host}/wiki-nodes`, body);
  }

  updateWikiNode(id: number, body: any) {
    return this.http.put<WikiNode>(`${this.host}/wiki-nodes/${id}`, body);
  }

  deleteWikiNode(id: number) {
    return this.http.delete<WikiNode>(`${this.host}/wiki-nodes/${id}`);
  }

  getWikiNodeApplicationEnvironments(id: number, params: any = {}) {
    return this.http.get<ApplicationEnvironment[]>(`${this.host}/wiki-nodes/${id}/application-environments`, { params: params });
  }

  /**
   * -------------------------------------------------- WIKI ARTICLE  --------------------------------------------------
   */
  getWikiArticle(id: string, params: any = {}) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<WikiArticle>(`${this.host}/wiki-articles/${id}`, {
      params: http_params,
    });
  }

  getWikiGithubArticle(filename: string, params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<{ metadata: any; content: string }>(`${this.host}/wiki-articles/github/${filename}`, { params: http_params });
  }

  updateWikiArticle(id: number, body: any) {
    return this.http.put<WikiArticle>(`${this.host}/wiki-articles/${id}`, body);
  }

  createWikiArticle(body: WikiArticle | any) {
    return this.http.post<WikiArticle>(`${this.host}/wiki-articles`, body);
  }

  deleteWikiArticle(id: number) {
    return this.http.delete<WikiArticle>(`${this.host}/wiki-articles/${id}`);
  }

  downloadWikiArticleAsPDF(id: number) {
    return this.http.get(`${this.host}/wiki-articles/${id}/pdf`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  /**
   * -------------------------------------------------- WIKI ARTICLE VERSION  --------------------------------------------------
   */
  createWikiArticleVersion(body: WikiArticleVersion) {
    return this.http.post<WikiArticleVersion>(`${this.host}/wiki-article-versions`, body, {
      headers: new HttpHeaders().set('avoid-snackbar-notification', 'true'),
    });
  }

  /**
   * -------------------------------------------------- APPLICATIONS --------------------------------------------------
   */
  getApplication(app_id: string, params: any = {}) {
    return this.http.get<Application>(`${this.host}/applications/${app_id}`, {
      params: params,
    });
  }

  createApplication(body: any) {
    return this.http.post<Application>(`${this.host}/applications`, body);
  }

  updateApplication(app_id: string, body: any) {
    return this.http.put<Application>(`${this.host}/applications/${app_id}`, body);
  }

  deleteApplication(app_id: string) {
    return this.http.delete<Application>(`${this.host}/applications/${app_id}`);
  }

  checkApplicationGithubConnection(app_id: string) {
    return this.http.get<{
      status: boolean;
      reason?: string;
      message?: string;
      install_url?: string;
      github_token_set?: boolean;
      data?: unknown;
    }>(`${this.host}/applications/${app_id}/check-github`);
  }

  /**
   * -------------------------------------------------- APPLICATION TYPES --------------------------------------------------
   */
  getApplicationTypes(params: any = {}) {
    return this.http.get<ApplicationType[]>(`${this.host}/application-types`, {
      params: params,
    });
  }

  /**
   * -------------------------------------------------- PROGRAMMING TAGS --------------------------------------------------
   */
  getProgrammingTags(params: any = {}) {
    return this.http.get<ProgrammingTag[]>(`${this.host}/programming-tags`, {
      params: params,
    });
  }

  createApplicationEnvironment(body: any) {
    return this.http.post<ApplicationEnvironment>(`${this.host}/application-environments`, body);
  }

  updateApplicationEnvironment(id: number, body: any) {
    return this.http.put<ApplicationEnvironment>(`${this.host}/application-environments/${id}`, body);
  }

  deleteApplicationEnvironment(id: number) {
    return this.http.delete<ApplicationEnvironment>(`${this.host}/application-environments/${id}`);
  }

  /**
   * -------------------------------------------------- COUNTRY ZONES --------------------------------------------------
   */
  getCountryZones(params: any = {}) {
    return this.http.get<CountryZone[]>(`${this.host}/country-zones`, {
      params: params,
    });
  }

  getCountryZoneHolidays(country_zone_id: string, params: any = {}) {
    return this.http.get<Holiday[]>(`${this.host}/country-zones/${country_zone_id}/holidays`, { params: params });
  }

  /**
   * -------------------------------------------------- HOLIDAYS --------------------------------------------------
   */
  updateHoliday(id: string, body: any) {
    return this.http.put<Holiday>(`${this.host}/holidays/${id}`, body);
  }

  /**
   * -------------------------------------------------- MESSAGING CONVERSATIONS --------------------------------------------------
   */
  getUserMessagingConversation(user_id: string, params: { provider?: 'google_chat' | 'teams' } = {}) {
    return this.http.get<MessagingConversation | null>(`${this.host}/users/${user_id}/messaging-conversations`, {
      params: this.setParams(params),
    });
  }

  getMessagingConversations(params: Record<string, string | number | boolean> = {}) {
    return this.http.get<ArrayResponse<MessagingConversation>>(`${this.host}/messaging-conversations`, {
      params: this.setParams(params),
    });
  }

  createMessagingConversation(body: Partial<MessagingConversation>) {
    return this.http.post<MessagingConversation>(`${this.host}/messaging-conversations`, body);
  }

  updateMessagingConversation(id: number | string, body: Partial<MessagingConversation>) {
    return this.http.put<MessagingConversation>(`${this.host}/messaging-conversations/${id}`, body);
  }

  deleteMessagingConversation(id: number | string) {
    return this.http.delete<MessagingConversation>(`${this.host}/messaging-conversations/${id}`);
  }

  syncMessagingConversations(body: { provider?: string; workspace_id?: number } = {}) {
    return this.http.post<{ created: number; updated: number; deactivated: number; total: number }>(
      `${this.host}/messaging-conversations/sync`,
      body
    );
  }

  assignMessagingConversationToCompany(id: number, body: { company_id: number }) {
    return this.http.post<MessagingConversation>(`${this.host}/messaging-conversations/${id}/assign-company`, body);
  }

  assignMessagingConversationToUser(id: number, body: { user_id: number }) {
    return this.http.post<MessagingConversation>(`${this.host}/messaging-conversations/${id}/assign-user`, body);
  }

  unassignMessagingConversation(id: number) {
    return this.http.post<MessagingConversation>(`${this.host}/messaging-conversations/${id}/unassign`, {});
  }

  ignoreMessagingConversationAssignment(id: number) {
    return this.http.post<MessagingConversation>(`${this.host}/messaging-conversations/${id}/ignore-for-assignment`, {});
  }

  /**
   * -------------------------------------------------- COMPANY NOTIFICATION CHANNELS --------------------------------------------------
   */

  /**
   * -------------------------------------------------- USER CHAT OAUTH CONNECTIONS --------------------------------------------------
   */
  getUserChatOAuthConnections(user_id: string) {
    return this.http
      .get<{ data: UserChatOAuthConnection[] }>(`${this.host}/users/${user_id}/user-chat-oauth-connections`)
      .pipe(map(response => response.data));
  }

  getUserChatSlackSlots(user_id: string) {
    return this.http.get<UserSlackChatSlot[]>(`${this.host}/users/${user_id}/user-chat-oauth-connections/slack-slots`);
  }

  startSlackChatOAuth(team_id: string) {
    return this.http.get<{ authorization_url: string }>(`${this.host}/user-chat-oauth-connections/slack/redirect`, {
      params: { team_id },
    });
  }

  startSlackBotInstallOAuth(company_id: string) {
    return this.http.get<{ authorization_url: string }>(`${this.host}/user-chat-oauth-connections/slack/bot/redirect`, {
      params: { company_id },
    });
  }

  disconnectCompanySlack(company_id: string) {
    return this.http.delete<Company>(`${this.host}/companies/${company_id}/slack-connection`);
  }

  deleteUserChatOAuthConnection(id: number) {
    return this.http.delete<UserChatOAuthConnection>(`${this.host}/user-chat-oauth-connections/${id}`);
  }

  /**
   * -------------------------------------------------- GOOGLE CHAT CONVERSATIONS --------------------------------------------------
   */

  getSlackWorkspaces() {
    return this.http.get<ArrayResponse<SlackWorkspace>>(`${this.host}/slack-workspaces`).pipe(map(response => response.data));
  }

  getSlackWorkspacesPaged(params: Record<string, unknown> = {}) {
    return this.http.get<ArrayResponse<SlackWorkspace>>(`${this.host}/slack-workspaces`, { params: params as any });
  }

  createSlackWorkspace(body: { team_id: string; name: string; bot_access_token: string }) {
    return this.http.post<SlackWorkspace>(`${this.host}/slack-workspaces`, body);
  }

  deleteSlackWorkspace(id: number) {
    return this.http.delete(`${this.host}/slack-workspaces/${id}`);
  }

  linkSlackWorkspace(id: number, body: { company_id: number }) {
    return this.http.post(`${this.host}/slack-workspaces/${id}/link`, body);
  }

  ignoreSlackWorkspace(id: number) {
    return this.http.post(`${this.host}/slack-workspaces/${id}/ignore`, {});
  }

  getMicrosoftTenantsPaged(params: Record<string, unknown> = {}) {
    return this.http.get<ArrayResponse<MicrosoftTenant>>(`${this.host}/microsoft-tenants`, { params: params as any });
  }

  downloadTeamsAppPackage() {
    return this.http.get(`${this.host}/microsoft-tenants/teams-app-package`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  linkMicrosoftTenant(id: number, body: { company_id: number }) {
    return this.http.post(`${this.host}/microsoft-tenants/${id}/link`, body);
  }

  ignoreMicrosoftTenant(id: number) {
    return this.http.post(`${this.host}/microsoft-tenants/${id}/ignore`, {});
  }

  getGoogleChatCustomersPaged(params: Record<string, unknown> = {}) {
    return this.http.get<ArrayResponse<GoogleChatCustomer>>(`${this.host}/google-chat-customers`, { params: params as any });
  }

  linkGoogleChatCustomer(id: number, body: { company_id: number }) {
    return this.http.post(`${this.host}/google-chat-customers/${id}/link`, body);
  }

  ignoreGoogleChatCustomer(id: number) {
    return this.http.post(`${this.host}/google-chat-customers/${id}/ignore`, {});
  }

  /**
   * -------------------------------------------------- COMPANY_PRODUCT TEAMS --------------------------------------------------
   */
  getCompanyProductTeam(id: string) {
    return this.http.get<CompanyProductTeam>(`${this.host}/company-product-teams/${id}`);
  }

  createCompanyProductTeam(body: UpsertCompanyProductTeamBody) {
    return this.http.post<CompanyProductTeam>(`${this.host}/company-product-teams`, body);
  }

  updateCompanyProductTeam(id: string, body: UpsertCompanyProductTeamBody) {
    return this.http.put<CompanyProductTeam>(`${this.host}/company-product-teams/${id}`, body);
  }

  deleteCompanyProductTeam(id: string) {
    return this.http.delete<CompanyProductTeam>(`${this.host}/company-product-teams/${id}`);
  }

  /**
   * -------------------------------------------------- COMPANY_PRODUCT TASK BOARD TIME BUDGET --------------------------------------------------
   */
  createProductTaskBoardTimeBudget(body: ProductTaskBoardTimeBudget, avoid_snackbar: boolean = false) {
    const headers: any = {};
    if (avoid_snackbar) headers['avoid-snackbar-notification'] = 'true';
    return this.http.post<ProductTaskBoardTimeBudget>(`${this.host}/product-task-board-time-budgets`, body, { headers: headers });
  }

  updateProductTaskBoardTimeBudget(id: number, body: any, avoid_snackbar: boolean = false) {
    const headers: any = {};
    if (avoid_snackbar) headers['avoid-snackbar-notification'] = 'true';
    return this.http.put<ProductTaskBoardTimeBudget>(`${this.host}/product-task-board-time-budgets/${id}`, body, { headers: headers });
  }

  deleteProductTaskBoardTimeBudget(id: number) {
    return this.http.delete<{
      deleted: boolean;
      board_was_deleted: boolean;
      product_task_board_id: number | null;
    }>(`${this.host}/product-task-board-time-budgets/${id}`);
  }

  /**
   * -------------------------------------------------- UPSKILLING / FORMATIONS --------------------------------------------------
   */

  /**
   * -------------------------------------------------- SKILLS --------------------------------------------------
   */
  getSkills(params: Record<string, unknown> = {}): Observable<ArrayResponse<Skill>> {
    return this.http.get<ArrayResponse<Skill>>(`${this.host}/skills`, {
      params: this.setParams(params),
    });
  }

  createSkill(body: SkillBody): Observable<Skill> {
    return this.http.post<Skill>(`${this.host}/skills`, body);
  }

  updateSkill(id: number, body: Partial<SkillBody>): Observable<Skill> {
    return this.http.put<Skill>(`${this.host}/skills/${id}`, body);
  }

  deleteSkill(id: number): Observable<void> {
    return this.http.delete<void>(`${this.host}/skills/${id}`);
  }

  /**
   * -------------------------------------------------- SKILL CATEGORIES --------------------------------------------------
   */
  getSkillCategories(params: Record<string, unknown>): Observable<ArrayResponse<SkillCategory>> {
    return this.http.get<ArrayResponse<SkillCategory>>(`${this.host}/skill-categories`, {
      params: this.setParams(params),
    });
  }

  getSkillCategory(id: number, params: Record<string, unknown> = {}): Observable<SkillCategory> {
    return this.http.get<SkillCategory>(`${this.host}/skill-categories/${id}`, {
      params: this.setParams(params),
    });
  }

  createSkillCategory(body: SkillCategoryBody): Observable<SkillCategory> {
    return this.http.post<SkillCategory>(`${this.host}/skill-categories`, body);
  }

  updateSkillCategory(id: number, body: Partial<SkillCategoryBody>): Observable<SkillCategory> {
    return this.http.put<SkillCategory>(`${this.host}/skill-categories/${id}`, body);
  }

  deleteSkillCategory(id: number): Observable<void> {
    return this.http.delete<void>(`${this.host}/skill-categories/${id}`);
  }

  /**
   * -------------------------------------------------- LEARNING RESOURCES --------------------------------------------------
   */
  getLearningResources(params: Record<string, unknown> = {}) {
    return this.http.get<ArrayResponse<LearningResource> | LearningResource[]>(`${this.host}/learning-resources`, {
      params: this.setParams(params),
    });
  }

  getLearningResourcesPaged(params: Record<string, unknown>) {
    return this.http.get<ArrayResponse<LearningResource>>(`${this.host}/learning-resources`, {
      params: this.setParams(params),
    });
  }

  createLearningResource(body: LearningResourceBody) {
    return this.http.post<LearningResource>(`${this.host}/learning-resources`, body);
  }

  updateLearningResource(id: number, body: Partial<LearningResourceBody>) {
    return this.http.put<LearningResource>(`${this.host}/learning-resources/${id}`, body);
  }

  deleteLearningResource(id: number) {
    return this.http.delete<void>(`${this.host}/learning-resources/${id}`);
  }

  /**
   * -------------------------------------------------- JOB DESCRIPTION TEMPLATES --------------------------------------------------
   */
  getJobDescriptionTemplatesPaged(params: Record<string, unknown>) {
    return this.http.get<ArrayResponse<JobDescriptionTemplate>>(`${this.host}/job-description-templates`, {
      params: this.setParams(params),
    });
  }

  getJobDescriptionTemplates(params: Record<string, unknown> = {}) {
    return this.http.get<ArrayResponse<JobDescriptionTemplate> | JobDescriptionTemplate[]>(`${this.host}/job-description-templates`, {
      params: this.setParams(params),
    });
  }

  createJobDescriptionTemplate(body: JobDescriptionTemplateBody) {
    return this.http.post<JobDescriptionTemplate>(`${this.host}/job-description-templates`, body);
  }

  updateJobDescriptionTemplate(id: number, body: Partial<JobDescriptionTemplateBody>) {
    return this.http.put<JobDescriptionTemplate>(`${this.host}/job-description-templates/${id}`, body);
  }

  deleteJobDescriptionTemplate(id: number) {
    return this.http.delete<void>(`${this.host}/job-description-templates/${id}`);
  }

  /**
   * -------------------------------------------------- SKILL QUESTIONS --------------------------------------------------
   */
  getSkillQuestionsPaged(params: Record<string, unknown>) {
    return this.http.get<ArrayResponse<SkillQuestion>>(`${this.host}/skill-questions`, {
      params: this.setParams(params),
    });
  }

  getSkillQuestions(params: Record<string, unknown> = {}) {
    return this.http.get<ArrayResponse<SkillQuestion> | SkillQuestion[]>(`${this.host}/skill-questions`, {
      params: this.setParams(params),
    });
  }

  getSkillQuestion(id: number, params: Record<string, unknown> = {}) {
    return this.http.get<SkillQuestion>(`${this.host}/skill-questions/${id}`, {
      params: this.setParams(params),
    });
  }

  createSkillQuestion(body: SkillQuestionBody) {
    return this.http.post<SkillQuestion>(`${this.host}/skill-questions`, body);
  }

  updateSkillQuestion(id: number, body: Partial<SkillQuestionBody>) {
    return this.http.put<SkillQuestion>(`${this.host}/skill-questions/${id}`, body);
  }

  deleteSkillQuestion(id: number) {
    return this.http.delete<void>(`${this.host}/skill-questions/${id}`);
  }

  suggestSkillQuestionRubric(body: SkillQuestionRubricSuggestionRequest) {
    return this.http.post<SkillQuestionRubricSuggestionResponse>(`${this.host}/skill-questions/suggest-rubric`, body);
  }

  /**
   * -------------------------------------------------- EXAM TEMPLATES --------------------------------------------------
   */
  getExamTemplatesPaged(params: Record<string, unknown>) {
    return this.http.get<ArrayResponse<ExamTemplate>>(`${this.host}/exam-templates`, {
      params: this.setParams(params),
    });
  }

  getExamTemplates(params: Record<string, unknown> = {}) {
    return this.http.get<ArrayResponse<ExamTemplate> | ExamTemplate[]>(`${this.host}/exam-templates`, {
      params: this.setParams(params),
    });
  }

  getExamTemplate(id: number, params: Record<string, unknown> = {}) {
    return this.http.get<ExamTemplate>(`${this.host}/exam-templates/${id}`, {
      params: this.setParams(params),
    });
  }

  createExamTemplate(body: ExamTemplateBody) {
    return this.http.post<ExamTemplate>(`${this.host}/exam-templates`, body);
  }

  updateExamTemplate(id: number, body: Partial<ExamTemplateBody>) {
    return this.http.put<ExamTemplate>(`${this.host}/exam-templates/${id}`, body);
  }

  deleteExamTemplate(id: number) {
    return this.http.delete<void>(`${this.host}/exam-templates/${id}`);
  }

  /**
   * -------------------------------------------------- EXAM INSTANCES --------------------------------------------------
   */
  getExamInstancesPaged(params: Record<string, unknown>) {
    return this.http.get<ArrayResponse<ExamInstance>>(`${this.host}/exam-instances`, {
      params: this.setParams(params),
    });
  }

  getExamInstances(params: Record<string, unknown> = {}) {
    return this.http.get<ArrayResponse<ExamInstance> | ExamInstance[]>(`${this.host}/exam-instances`, {
      params: this.setParams(params),
    });
  }

  getExamInstance(id: number, params: Record<string, unknown> = {}) {
    return this.http.get<ExamInstance>(`${this.host}/exam-instances/${id}`, {
      params: this.setParams(params),
    });
  }

  createExamInstance(body: ExamInstanceBody) {
    return this.http.post<ExamInstance>(`${this.host}/exam-instances`, body);
  }

  createExamInstanceFromTemplate(body: ExamInstanceFromTemplateBody) {
    return this.http.post<ExamInstance>(`${this.host}/exam-instances/from-template`, body);
  }

  updateExamInstance(id: number, body: ExamInstanceUpdateBody) {
    return this.http.put<ExamInstance>(`${this.host}/exam-instances/${id}`, body);
  }

  deleteExamInstance(id: number) {
    return this.http.delete<void>(`${this.host}/exam-instances/${id}`);
  }

  /**
   * -------------------------------------------------- EXAM INSTANCE EVALUATIONS --------------------------------------------------
   */
  getExamInstanceEvaluationsPaged(params: Record<string, unknown>) {
    return this.http.get<ArrayResponse<ExamInstanceEvaluation>>(`${this.host}/exam-instance-evaluations`, {
      params: this.setParams(params),
    });
  }

  getMyExamInstanceEvaluationsPaged(params: Record<string, unknown> = {}) {
    return this.http.get<ArrayResponse<ExamInstanceEvaluation>>(`${this.host}/me/exam-instance-evaluations`, {
      params: this.setParams(params),
    });
  }

  getExamInstanceEvaluations(params: Record<string, unknown> = {}) {
    return this.http.get<ArrayResponse<ExamInstanceEvaluation> | ExamInstanceEvaluation[]>(`${this.host}/exam-instance-evaluations`, {
      params: this.setParams(params),
    });
  }

  getExamInstanceEvaluation(id: number, params: Record<string, unknown> = {}) {
    return this.http.get<ExamInstanceEvaluation>(`${this.host}/exam-instance-evaluations/${id}`, {
      params: this.setParams(params),
    });
  }

  createExamInstanceEvaluation(body: ExamInstanceEvaluationBody) {
    return this.http.post<ExamInstanceEvaluation>(`${this.host}/exam-instance-evaluations`, body);
  }

  updateExamInstanceEvaluation(id: number, body: ExamInstanceEvaluationUpdateBody) {
    return this.http.put<ExamInstanceEvaluation>(`${this.host}/exam-instance-evaluations/${id}`, body);
  }

  deleteExamInstanceEvaluation(id: number) {
    return this.http.delete<void>(`${this.host}/exam-instance-evaluations/${id}`);
  }

  correctExamInstanceEvaluation(id: number) {
    return this.http.post<ExamInstanceEvaluation>(`${this.host}/exam-instance-evaluations/${id}/correct`, {});
  }

  importExamInstanceEvaluationPdf(id: number, file: File) {
    const form_data = new FormData();
    form_data.append('file', file);

    return this.http.post<ExamInstanceEvaluation>(`${this.host}/exam-instance-evaluations/${id}/import-pdf`, form_data);
  }

  exportExamInstanceEvaluationPdf(id: number) {
    return this.http.get(`${this.host}/exam-instance-evaluations/${id}/export-pdf`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  downloadExamInstanceEvaluationImportedPdf(id: number) {
    return this.http.get(`${this.host}/exam-instance-evaluations/${id}/download-imported-pdf`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  exportExamInstanceEvaluationsPdf(exam_instance_id: number) {
    return this.http.get(`${this.host}/exam-instances/${exam_instance_id}/export-evaluations-pdf`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  /**
   * -------------------------------------------------- JOB VACANCIES --------------------------------------------------
   */
  getJobVacanciesPaged(params: Record<string, unknown>) {
    return this.http.get<ArrayResponse<JobVacancy>>(`${this.host}/job-vacancies`, {
      params: this.setParams(params),
    });
  }

  getJobVacancy(id: number, params: Record<string, unknown> = {}) {
    return this.http.get<JobVacancy>(`${this.host}/job-vacancies/${id}`, {
      params: this.setParams(params),
    });
  }

  createJobVacancy(body: JobVacancyBody) {
    return this.http.post<JobVacancy>(`${this.host}/job-vacancies`, body);
  }

  updateJobVacancy(id: number, body: Partial<JobVacancyBody>) {
    return this.http.put<JobVacancy>(`${this.host}/job-vacancies/${id}`, body);
  }

  deleteJobVacancy(id: number) {
    return this.http.delete<void>(`${this.host}/job-vacancies/${id}`);
  }

  /**
   * -------------------------------------------------- JOB CANDIDATES --------------------------------------------------
   */
  getJobCandidatesPaged(params: Record<string, unknown>) {
    return this.http.get<ArrayResponse<JobCandidate>>(`${this.host}/job-vacancy-candidates`, {
      params: this.setParams(params),
    });
  }

  createJobCandidate(body: JobCandidateBody) {
    return this.http.post<JobCandidate>(`${this.host}/job-vacancy-candidates`, body);
  }

  updateJobCandidate(id: number, body: Partial<JobCandidateUpdateBody>) {
    return this.http.put<JobCandidate>(`${this.host}/job-vacancy-candidates/${id}`, body);
  }

  discardJobCandidate(id: number) {
    return this.http.post<JobCandidate>(`${this.host}/job-vacancy-candidates/${id}/discard`, {});
  }

  /**
   * -------------------------------------------------- JOB VACANCY PHASES --------------------------------------------------
   */
  updateJobVacancyPhase(id: number, body: Partial<JobVacancyPhase>) {
    return this.http.put<JobVacancyPhase>(`${this.host}/job-vacancy-phases/${id}`, body);
  }

  /**
   * -------------------------------------------------- JOB CANDIDATE MEETING RECORDS --------------------------------------------------
   */
  getJobCandidate(id: number, params: Record<string, unknown> = {}) {
    return this.http.get<JobCandidate>(`${this.host}/job-vacancy-candidates/${id}`, {
      params: this.setParams(params),
    });
  }

  /**
   * -------------------------------------------------- LEARNING RESOURCE ENROLLMENTS --------------------------------------------------
   */
  getLearningResourceEnrollments(params: Record<string, unknown>) {
    return this.http.get<ArrayResponse<LearningResourceEnrollment>>(`${this.host}/learning-resource-enrollments`, {
      params: this.setParams(params),
    });
  }

  activateLearningResourceEnrollment(body: {
    user_id: number;
    learning_resource_id: number;
    start_date?: string;
    complete_active_enrollment?: boolean;
    close_enrollment_ids?: number[];
    complete_enrollment_ids?: number[];
  }) {
    return this.http.post<LearningResourceEnrollment>(`${this.host}/learning-resource-enrollments/activate`, body);
  }

  completeActiveLearningResourceEnrollment(body: { user_id: number; completion_date?: string; learning_resource_enrollment_id?: number }) {
    return this.http.post<LearningResourceAchievement>(`${this.host}/learning-resource-enrollments/complete-active`, body);
  }

  getActiveLearningResourceEnrollmentsForUser(userId: number) {
    return this.http.get<LearningResourceEnrollment[]>(`${this.host}/users/${userId}/active-learning-resource-enrollments`);
  }

  /**
   * -------------------------------------------------- LEARNING RESOURCE ACHIEVEMENTS --------------------------------------------------
   */
  getUserLearningResourceAchievements(userId: number) {
    return this.http.get<LearningResourceAchievement[]>(`${this.host}/users/${userId}/learning-resource-achievements`);
  }

  createLearningResourceAchievement(body: { user_id: number; learning_resource_id: number; start_date: string; end_date: string | null }) {
    return this.http.post<LearningResourceAchievement>(`${this.host}/learning-resource-achievements`, body);
  }

  updateLearningResourceAchievement(
    id: number,
    body: {
      user_id?: number;
      learning_resource_id?: number;
      start_date?: string;
      end_date?: string | null;
    }
  ) {
    return this.http.put<LearningResourceAchievement>(`${this.host}/learning-resource-achievements/${id}`, body);
  }

  deleteLearningResourceAchievement(id: number) {
    return this.http.delete<void>(`${this.host}/learning-resource-achievements/${id}`);
  }

  /**
   * -------------------------------------------------- LEARNING RESOURCE REQUESTS --------------------------------------------------
   */
  createLearningResourceRequest(body: Partial<LearningResourceRequest>) {
    return this.http.post<LearningResourceRequest>(`${this.host}/learning-resource-requests`, body);
  }

  /**
   * -------------------------------------------------- POSTGRES BISUAL DATABASE GRANT REQUESTS --------------------------------------------------
   */
  createPostgresBisualDatabaseGrantRequest(body: { reason: string }) {
    return this.http.post<{ expected_end_date: string }>(`${this.host}/postgres-bisual-database-grant-requests`, body);
  }

  getLearningResourceRequestsPaged(params: Record<string, unknown>) {
    return this.http.get<ArrayResponse<LearningResourceRequest>>(`${this.host}/learning-resource-requests`, {
      params: this.setParams(params),
    });
  }

  getSurveys(params: Record<string, unknown>): Observable<ArrayResponse<Survey>> {
    return this.http.get<ArrayResponse<Survey>>(`${this.host}/surveys`, {
      params: this.setParams(params),
    });
  }

  getSurvey(id: number, params: Record<string, unknown> = {}): Observable<Survey> {
    return this.http.get<Survey>(`${this.host}/surveys/${id}`, {
      params: this.setParams(params),
    });
  }

  updateSurvey(id: number, body: UpsertSurveyBody): Observable<Survey> {
    return this.http.put<Survey>(`${this.host}/surveys/${id}`, body);
  }

  createSurvey(body: UpsertSurveyBody): Observable<Survey> {
    return this.http.post<Survey>(`${this.host}/surveys`, body);
  }

  updateSurveyVariableConditionSection(
    id: number,
    body: UpdateSurveyVariableConditionSectionBody
  ): Observable<SurveyVariableConditionSection> {
    return this.http.put<SurveyVariableConditionSection>(`${this.host}/survey-variable-condition-sections/${id}`, body);
  }

  deleteSurveyVariableConditionSection(id: number): Observable<void> {
    return this.http.delete<void>(`${this.host}/survey-variable-condition-sections/${id}`);
  }

  getSurveysKpis(): Observable<SurveyKpis> {
    return this.http.get<SurveyKpis>(`${this.host}/surveys/kpis`);
  }

  acceptLearningResourceRequest(id: number, body: AcceptLearningResourceRequestBody) {
    return this.http.post<LearningResourceRequest>(`${this.host}/learning-resource-requests/${id}/accept`, body);
  }

  declineLearningResourceRequest(id: number) {
    return this.http.post<LearningResourceRequest>(`${this.host}/learning-resource-requests/${id}/decline`, {});
  }

  /**
   * ------------------------------------ COMPANY_PRODUCT TASK DESIGN LINKS ------------------------------------
   */

  createProductTaskDesignLink(body: ProductTaskDesignLink | any) {
    return this.http.post<ProductTaskDesignLink>(`${this.host}/product-task-design-links`, body);
  }

  updateProductTaskDesignLink(body: ProductTaskDesignLink | any) {
    return this.http.put<ProductTaskDesignLink>(`${this.host}/product-task-design-links/${body.id}`, body);
  }

  deleteProductTaskDesignLink(body: ProductTaskDesignLink | any) {
    return this.http.delete<ProductTaskDesignLink>(`${this.host}/product-task-design-links/${body.id}`);
  }

  getProductTaskDesignLink(body: any) {
    return this.http.get<ProductTaskDesignLink>(`${this.host}/product-task-design-links/${body.id}`);
  }

  /**
   * -------------------------------------------------- COMPUTER --------------------------------------------------
   */
  getComputers(params: any = {}) {
    return this.http.get<ArrayResponse<Computer>>(`${this.host}/computers`, {
      params: params,
    });
  }

  createComputer(body: Computer) {
    return this.http.post<Computer>(`${this.host}/computers`, body);
  }

  updateComputer(id: number, body: Computer) {
    return this.http.put<Computer>(`${this.host}/computers/${id}`, body);
  }

  attachUserToComputer(computer_id: number, user_id: number) {
    return this.http.post<Computer>(`${this.host}/computers/${computer_id}/attach`, { user_id: user_id });
  }

  dettachUserFromComputer(computer_id: number) {
    return this.http.post<Computer>(`${this.host}/computers/${computer_id}/dettach`, {});
  }

  /**
   * -------------------------------------------------- PAYROLL --------------------------------------------------
   */
  downloadPayrollPdf(id: string) {
    return this.http.get(`${this.host}/payrolls/${id}/download`, {
      observe: 'response',
      responseType: 'blob',
    });
  }

  downloadBulkPayrollsXlsx(params: any = {}) {
    const http_params = this.setParams({
      from: params.from,
      to: params.to,
      user_id: params.user_id,
    });

    return this.http.get(`${this.host}/payrolls/bulk-download`, {
      params: http_params,
      observe: 'response',
      responseType: 'blob',
    });
  }

  preparePayrolls(from: dayjs.Dayjs, to: dayjs.Dayjs, regenerate: boolean = false) {
    return this.http.post<LongTask>(`${this.host}/payrolls/prepare`, {
      from: from.format('YYYY-MM-DD'),
      to: to.format('YYYY-MM-DD'),
      regenerate,
    });
  }

  importPayrollGestoriaPdf(file: File, from: dayjs.Dayjs, to: dayjs.Dayjs) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('from', from.format('YYYY-MM-DD'));
    formData.append('to', to.format('YYYY-MM-DD'));

    return this.http.post<LongTask>(`${this.host}/payrolls/import-gestoria-pdf`, formData);
  }

  getPayrollGestoriaImport(from: dayjs.Dayjs, to: dayjs.Dayjs) {
    return this.http.get<import('../models/payroll-accounting-import.model').PayrollAccountingImport | null>(
      `${this.host}/payrolls/gestoria-import`,
      {
        params: {
          from: from.format('YYYY-MM-DD'),
          to: to.format('YYYY-MM-DD'),
        },
      }
    );
  }

  rematchPayrollGestoriaImport(from: dayjs.Dayjs, to: dayjs.Dayjs) {
    return this.http.post<import('../models/payroll-accounting-import.model').PayrollAccountingImport | null>(
      `${this.host}/payrolls/gestoria-import/rematch`,
      {
        from: from.format('YYYY-MM-DD'),
        to: to.format('YYYY-MM-DD'),
      }
    );
  }

  updatePayrollGestoriaDraft(draftId: number, body: Partial<import('../models/payroll-accounting-draft.model').PayrollAccountingDraft>) {
    return this.http.put<import('../models/payroll-accounting-draft.model').PayrollAccountingDraft>(
      `${this.host}/payrolls/gestoria-drafts/${draftId}`,
      body
    );
  }

  confirmPayrollGestoriaImport(importId: number, draftIds: number[]) {
    return this.http.post<{
      synced: number;
      failed: number;
      skipped: number;
      results: Array<{ draft_id: number; status: string; message?: string; holded_salary_record_id?: string }>;
      drafts: Array<import('../models/payroll-accounting-draft.model').PayrollAccountingDraft>;
    }>(`${this.host}/payrolls/gestoria-imports/${importId}/confirm`, {
      draft_ids: draftIds,
    });
  }

  getPayrollMileageTrips(payroll_id: number): Observable<PayrollMileageTripsResponseDTO> {
    return this.http.get<PayrollMileageTripsResponseDTO>(`${this.host}/payrolls/${payroll_id}/mileage-trips`);
  }

  getPayrolls(params: any = {}) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<Payroll>>(`${this.host}/payrolls`, {
      params: http_params,
    });
  }

  // createPayrolls(body: {payrolls: any[]; payroll_date: string; general_comment: string | null;}) {
  createPayrollsBulk(payrolls: Payroll[]) {
    const formData = new FormData();

    payrolls.forEach((p, i) => {
      // Primero añade todos los campos normales
      Object.keys(p).forEach(key => {
        if (key === 'payroll_file') return;
        formData.append(`payrolls[${i}][${key}]`, (p as any)[key]);
      });

      // Luego añade el File
      if ((p as any).payroll_file instanceof File) {
        formData.append(`payrolls[${i}][payroll_file]`, (p as any).payroll_file);
      }
    });

    return this.http.post(`${this.host}/payrolls/bulk`, formData);
  }

  sendPayrollsToTheManagement(working_period_from: Date, working_period_to: Date) {
    return this.http.post<Payroll[]>(`${this.host}/payrolls/send-to-the-management`, {
      working_period_from: dayjs(working_period_from).format('YYYY-MM-DD'),
      working_period_to: dayjs(working_period_to).format('YYYY-MM-DD'),
    });
  }

  sendPayrollsToTheEmployee(working_period_from: Date, working_period_to: Date) {
    return this.http.post<Payroll[]>(`${this.host}/payrolls/send-to-the-employees`, {
      working_period_from: dayjs(working_period_from).format('YYYY-MM-DD'),
      working_period_to: dayjs(working_period_to).format('YYYY-MM-DD'),
    });
  }

  /**
   * -------------------------------------------------- COMPANY_PRODUCT EPIC --------------------------------------------------
   */
  createCompanyProductEpic(epic: CompanyProductEpic) {
    return this.http.post<CompanyProductEpic>(`${this.host}/company-product-epics`, epic);
  }

  getProductTaskOriginCategories(): Observable<ArrayResponse<ProductTaskOriginCategory>> {
    return this.http.get<ArrayResponse<ProductTaskOriginCategory>>(`${this.host}/product-task-origin-categories`);
  }

  /**
   * -------------------------------------------------- DOCUMENTS --------------------------------------------------
   */
  getDocumentsByUser(
    userId: string,
    params: {
      page: number;
      per_page: number;
      document_type_ids?: string;
      search?: string;
    } = { page: 1, per_page: 10 }
  ): Observable<ArrayResponse<Document>> {
    let httpParams = new HttpParams().set('page', params.page).set('per_page', params.per_page);

    if (params.document_type_ids !== undefined) httpParams = httpParams.set('document_type_ids', params.document_type_ids);
    if (params.search !== undefined) httpParams = httpParams.set('search', params.search);

    return this.http.get<ArrayResponse<Document>>(`${this.host}/users/${userId}/documents`, {
      params: httpParams,
    });
  }

  createDocument(formData: FormData): Observable<Document> {
    return this.http.post<Document>(`${this.host}/documents`, formData);
  }

  getMaxUploadSize(): Observable<number> {
    return this.http.get<number>(`${this.host}/utils/max-upload-size`);
  }

  getRelatedModels(model: string, userId: number) {
    return this.http.get<any[]>(`${this.host}/documents/related-models`, {
      params: { model, user_id: userId },
    });
  }

  updateDocument(
    id: number,
    body: { comment?: string; start_date: string; end_date: string | null; related_id: number }
  ): Observable<Document> {
    return this.http.put<Document>(`${this.host}/documents/${id}`, body);
  }

  downloadDocument(id: number) {
    return this.http.get(`${this.host}/documents/${id}/download`, {
      responseType: 'blob',
    });
  }

  deleteDocument(id: number) {
    return this.http.delete(`${this.host}/documents/${id}`);
  }

  /**
   * -------------------------------------------------- DOCUMENT TYPES --------------------------------------------------
   */

  getDocumentTypes(params: {
    page?: number;
    per_page?: number;
    related_type?: DocumentRelatedType;
    search?: string;
    user_id?: string;
    should_filter_only_existing_document_types?: boolean;
  }): Observable<ArrayResponse<DocumentType>> {
    let httpParams = new HttpParams();
    if (params.page) httpParams = httpParams.set('page', params.page);
    if (params.per_page) httpParams = httpParams.set('per_page', params.per_page);

    if (params.related_type) httpParams = httpParams.set('related_type', params.related_type);
    if (params.search) httpParams = httpParams.set('search', params.search);
    if (params.user_id) httpParams = httpParams.set('user_id', params.user_id);
    if (params.should_filter_only_existing_document_types !== undefined)
      httpParams = httpParams.set(
        'should_filter_only_existing_document_types',
        params.should_filter_only_existing_document_types ? '1' : '0'
      );

    return this.http.get<ArrayResponse<DocumentType>>(`${this.host}/documents/types`, { params: httpParams });
  }

  createDocumentType(data: { name: string; related_type: DocumentRelatedType; related_user_can_view_document: boolean }) {
    return this.http.post(`${this.host}/documents/types`, data);
  }

  deleteDocumentType(id: number): Observable<any> {
    return this.http.delete(`${this.host}/documents/types/${id}`);
  }

  /**
   * -------------------------------------------------- CONTRACTS --------------------------------------------------
   */
  getProductionPlanification(year: number) {
    return this.http.get<{ data: ProductionPlanification; calculated_at: string } | LongTask>(
      `${this.host}/contracts/production-planification`,
      { params: { year: year.toString() } }
    );
  }

  postProductionPlanificationCalculate(year: number) {
    return this.http.post<LongTask>(`${this.host}/contracts/production-planification/calculate`, { year });
  }

  getLongTasks(
    params: {
      status?: LongTaskStatus;
      type?: string;
      [key: string]: string | LongTaskStatus | undefined;
    } = {}
  ): Observable<ArrayResponse<LongTask>> {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<LongTask>>(`${this.host}/long-tasks`, {
      params: http_params,
    });
  }

  getLongTaskResult(longTaskId: number) {
    return this.http.get<any>(`${this.host}/long-tasks/${longTaskId}/result`);
  }

  downloadProductionPlanificationResult(longTaskId: number) {
    return this.getLongTaskResult(longTaskId);
  }

  /**
   * -------------------------------------------------- AbsenceRequest --------------------------------------------------
   */

  createAbsenceRequest(data: AbsenceRequestUpsertPayload, options: { headers?: HttpHeaders } = {}) {
    return this.http.post<AbsenceRequest>(`${this.host}/absence-requests`, data, options);
  }

  modifyAbsenceRequest(
    absenceRequestId: number,
    data: AbsenceRequestUpsertPayload,
    options: HttpRequestOptions
  ): Observable<AbsenceRequest> {
    return this.http.put<AbsenceRequest>(`${this.host}/absence-requests/${absenceRequestId}/modify`, data, {
      headers: options.headers,
    });
  }

  getAllAbsenceRequestWorkingTimeCategories(params: HttpQueryParams = {}): Observable<WorkingTimeCategory[]> {
    return this.http.get<WorkingTimeCategory[]>(`${this.host}/working-time-categories/absence-request-categories`, { params: params });
  }

  getAbsenceRequests(params: HttpQueryParams = {}): Observable<ArrayResponse<AbsenceRequest>> {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<AbsenceRequest>>(`${this.host}/absence-requests`, { params: http_params });
  }

  rejectAbsenceRequest(id: number) {
    return this.http.post<AbsenceRequest>(`${this.host}/absence-requests/${id}/reject`, {});
  }

  approveAbsenceRequest(id: number) {
    return this.http.post<AbsenceRequest>(`${this.host}/absence-requests/${id}/approve`, {});
  }

  uploadAbsenceRequestDocument(id: number, body: FormData) {
    return this.http.post<AbsenceRequest>(`${this.host}/absence-requests/${id}/upload-document`, body);
  }

  deleteAbsenceRequest(id: number): Observable<AbsenceRequest> {
    return this.http.delete<AbsenceRequest>(`${this.host}/absence-requests/${id}`);
  }

  /**
   * -------------------------------------------------- WORKING EXTRA HOURS PERIODS --------------------------------------------------
   */
  getWorkingExtraHoursPeriods(params: any = null) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<WorkingExtraHoursPeriod>>(`${this.host}/working-extra-hours-periods`, { params: http_params });
  }

  getWorkingExtraHoursPeriod(id: number) {
    return this.http.get<WorkingExtraHoursPeriod>(`${this.host}/working-extra-hours-periods/${id}`);
  }

  createWorkingExtraHoursPeriod(body: WorkingExtraHoursPeriod) {
    return this.http.post<WorkingExtraHoursPeriod>(`${this.host}/working-extra-hours-periods`, body);
  }

  updateWorkingExtraHoursPeriod(id: number, body: any) {
    return this.http.put<WorkingExtraHoursPeriod>(`${this.host}/working-extra-hours-periods/${id}`, body);
  }

  deleteWorkingExtraHoursPeriod(id: number) {
    return this.http.delete<WorkingExtraHoursPeriod>(`${this.host}/working-extra-hours-periods/${id}`);
  }

  getWorkingExtraHoursPeriodCreationContext() {
    return this.http.get<{ requires_at_least_one_company_product: boolean }>(`${this.host}/me/working-extra-hours-period-creation-context`);
  }

  /**
   * -------------------------------------------------- DRIVING REQUESTS --------------------------------------------------
   */
  getDrivingRequests(params: HttpQueryParams = {}): Observable<ArrayResponse<DrivingRequest>> {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<DrivingRequest>>(`${this.host}/driving-requests`, { params: http_params });
  }

  updateDrivingRequest(id: number, body: UpdateDrivingRequestBody): Observable<DrivingRequest> {
    return this.http.put<DrivingRequest>(`${this.host}/driving-requests/${id}`, body);
  }

  getDrivingRequestResolutionContext(id: number): Observable<DrivingRequestResolutionContext> {
    return this.http.get<DrivingRequestResolutionContext>(`${this.host}/driving-requests/${id}/resolution-context`);
  }

  // Employee Calendar Register Notification Requests
  getEmployeeCalendarRegisterNotificationRequests(ecrId: number, userId: number) {
    return this.http.get<EmployeeCalendarRegisterNotificationRequest[]>(
      `${this.host}/employee-calendar-registers/${ecrId}/users/${userId}/employee-calendar-register-notification-requests`
    );
  }

  /**
   * -------------------------------------------------- COMPANY_PRODUCT MONTHLY ECONOMIC REPORTS --------------------------------------------------
   */
  getCompanyProductMonthlyEconomicReports(
    params: {
      company_product_id?: number;
      year?: number;
      company_id?: number;
      billed_start_date?: string;
      billed_from?: string;
      billed_to?: string;
      with?: string;
      append?: string;
      order_by?: string;
      per_page?: number;
      page?: number;
    } = {}
  ) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<CompanyProductMonthlyEconomicReport>>(`${this.host}/company-product-monthly-economic-reports`, {
      params: http_params,
    });
  }

  getCompanyProductMonthlyEconomicReport(id: number, query: { with?: string; append?: string } = {}) {
    const http_params: HttpParams = this.setParams(query);
    return this.http.get<CompanyProductMonthlyEconomicReport>(`${this.host}/company-product-monthly-economic-reports/${id}`, {
      params: http_params,
    });
  }

  updateCompanyProductMonthlyEconomicReport(id: number, body: { comment: string | null }) {
    return this.http.put<CompanyProductMonthlyEconomicReport>(`${this.host}/company-product-monthly-economic-reports/${id}`, body);
  }

  getInvoices(
    params: {
      company_product_id?: number;
      receiver_company_id?: number;
      scopes?: string;
      with?: string;
      append?: string;
      order_by?: string;
      per_page?: number;
      page?: number;
    } = {}
  ) {
    const http_params: HttpParams = this.setParams(params);
    return this.http.get<ArrayResponse<Invoice>>(`${this.host}/invoices`, { params: http_params });
  }

  getInvoice(id: number, query: { with?: string; append?: string } = {}) {
    const http_params: HttpParams = this.setParams(query);
    return this.http.get<Invoice>(`${this.host}/invoices/${id}`, { params: http_params });
  }

  storeCompanyProductMonthlyEconomicReportInvoiceConciliation(body: {
    invoice_id: number;
    company_product_monthly_economic_report_id: number;
    invoice_line_id?: number | null;
    hours_conciliated: number;
    amount_conciliated: number;
    comment?: string | null;
  }) {
    return this.http.post<CompanyProductMonthlyEconomicReportInvoiceConciliation>(
      `${this.host}/company-product-monthly-economic-report-invoice-conciliations`,
      body
    );
  }

  destroyCompanyProductMonthlyEconomicReportInvoiceConciliation(id: number) {
    return this.http.delete<void>(`${this.host}/company-product-monthly-economic-report-invoice-conciliations/${id}`);
  }

  /**
   * -------------------------------------------------- HOLDED AUTOCOMPLETE --------------------------------------------------
   */
  searchHoldedContacts(query: string, limit: number = 25) {
    const http_params: HttpParams = this.setParams({ query, limit });
    return this.http.get<HoldedContact[]>(`${this.host}/holded/contacts`, {
      params: http_params,
    });
  }

  listHoldedChartOfAccounts(scope: 'income' | 'payroll' = 'income') {
    return this.http.get<HoldedChartOfAccount[]>(`${this.host}/holded/chart-of-accounts`, {
      params: { scope },
    });
  }
}
